webpackJsonp([2,0],{

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(1038);
	
	__webpack_require__(1039);
	
	var _elementUi = __webpack_require__(1022);
	
	var _elementUi2 = _interopRequireDefault(_elementUi);
	
	var _en = __webpack_require__(1025);
	
	var _en2 = _interopRequireDefault(_en);
	
	__webpack_require__(1040);
	
	__webpack_require__(1041);
	
	var _vCharts = __webpack_require__(1102);
	
	var _vCharts2 = _interopRequireDefault(_vCharts);
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _vueAnimateNumber = __webpack_require__(1103);
	
	var _vueAnimateNumber2 = _interopRequireDefault(_vueAnimateNumber);
	
	var _vueEventCalendar = __webpack_require__(1105);
	
	var _vueEventCalendar2 = _interopRequireDefault(_vueEventCalendar);
	
	var _vueGmaps = __webpack_require__(1106);
	
	var _vueGmaps2 = _interopRequireDefault(_vueGmaps);
	
	var _vueResource = __webpack_require__(1173);
	
	var _vueResource2 = _interopRequireDefault(_vueResource);
	
	var _vueRouter = __webpack_require__(514);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	var _vuebars = __webpack_require__(1176);
	
	var _vuebars2 = _interopRequireDefault(_vuebars);
	
	var _vuelayers = __webpack_require__(1183);
	
	var _vuelayers2 = _interopRequireDefault(_vuelayers);
	
	__webpack_require__(1053);
	
	var _vuelidate = __webpack_require__(1385);
	
	var _vuelidate2 = _interopRequireDefault(_vuelidate);
	
	var _vueAvatar = __webpack_require__(1104);
	
	var _vueTyper = __webpack_require__(1175);
	
	var _App = __webpack_require__(1107);
	
	var _App2 = _interopRequireDefault(_App);
	
	var _routes = __webpack_require__(657);
	
	var _routes2 = _interopRequireDefault(_routes);
	
	var _index = __webpack_require__(661);
	
	var _index2 = _interopRequireDefault(_index);
	
	var _vuex = __webpack_require__(30);
	
	var _vuex2 = _interopRequireDefault(_vuex);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_vue2.default.use(_vuelidate2.default);
	
	_vue2.default.use(_vueResource2.default);
	_vue2.default.http.options.emulateJSON = true;
	
	_vue2.default.use(_vueRouter2.default);
	_vue2.default.use(_elementUi2.default, {
	  locale: _en2.default
	});
	_vue2.default.use(_vuebars2.default);
	_vue2.default.use(_vueEventCalendar2.default, {
	  locale: 'en'
	});
	_vue2.default.use(_vueAnimateNumber2.default);
	_vue2.default.use(_vueGmaps2.default, {
	  key: 'AIzaSyCpr35b_ZSoP8nbz0VnBjVz6ABb7iurRCU',
	  libraries: ['places'],
	  version: '3'
	});
	_vue2.default.use(_vuelayers2.default);
	_vue2.default.use(_vCharts2.default);
	_vue2.default.component('avatar', _vueAvatar.Avatar);
	_vue2.default.component('vue-typer', _vueTyper.VueTyper);
	_vue2.default.use(_vuex2.default);
	var store = new _vuex2.default.Store(_index2.default);
	var router = (0, _routes2.default)(store);
	
	new _vue2.default({
	  el: '#app',
	  router: router,
	  store: store,
	  render: function render(h) {
	    return h(_App2.default);
	  }
	});
	
	__webpack_require__(705);
	
	__webpack_require__(608);
	__webpack_require__(609);
	__webpack_require__(610);

/***/ }),

/***/ 51:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getUrl = exports.URL = undefined;
	
	var _keys = __webpack_require__(52);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var URL = exports.URL = {
	  GET_ANTIFORGERY_PREPARE: API_URL + "/antiforgery",
	  GET_ANTIFORGERY_TOKEN: API_URL + "/antiforgery/token",
	  POST_LOGIN: API_URL + "/auth/signin",
	  POST_JWT_REFRESH: API_URL + "/auth/refreshToken",
	  POST_FORGOT_PASSWORD: API_URL + "/auth/forgotpassword",
	  POST_RESET_PASSWORD: API_URL + "/auth/resetpassword",
	  GET_ACCOUNT_DETAILS: API_URL + "/me",
	
	  GET_USERS_LIST: API_URL + "/users",
	  GET_ROLES_LIST: API_URL + "/users/roles",
	  GET_USER: API_URL + "/users/{id}",
	  POST_USER: API_URL + "/users",
	  PUT_USER: API_URL + "/users/{id}",
	  DELETE_USER: API_URL + "/users/{id}",
	
	  GET_CUSTOMERS_LIST: API_URL + "/customers",
	  GET_CUSTOMER: API_URL + "/customers/{id}",
	  POST_CUSTOMER: API_URL + "/customers",
	  PUT_CUSTOMER: API_URL + "/customers/{id}",
	  PUT_CUSTOMER_SECRET_KEY: API_URL + "/customers/{id}/generate/key",
	  DELETE_CUSTOMER: API_URL + "/customers/{id}",
	
	  GET_DEVICES_LIST: API_URL + "/devices/list",
	  GET_DEVICES_SEARCH: API_URL + "/devices/search",
	  GET_DEVICE_STATUS: API_URL + "/devices/status",
	  GET_DEVICES_COUNT: API_URL + "/devices/count",
	  GET_DEVICE: API_URL + "/devices/{serial}",
	  POST_DEVICE: API_URL + "/devices",
	  PUT_DEVICE: API_URL + "/devices/{serial}",
	  DELETE_DEVICE: API_URL + "/devices/{serial}",
	  PATCH_DEVICE_RESTORE: API_URL + "/devices/{serial}",
	
	  GET_DEVICE_CONTENT: API_URL + "/devices/{serial}/content",
	
	  GET_DEVICE_CONTENT_URL: API_URL + "/devices/content/{contentId}",
	  POST_DEVICE_STATUS: API_URL + "/devices/status",
	
	  POST_VIDEO_SEARCH: API_URL + "/video/search",
	  POST_VIDEO_LIVE: API_URL + "/video/live",
	  POST_VIDEO_DOWNLOAD: API_URL + "/video/download",
	
	  POST_SNAPSHOT: API_URL + "/snapshot",
	
	  POST_XML_FILE: API_URL + "/config/pushXml",
	  GET_XML_FILE: API_URL + "/config/getXml"
	
	};
	
	var getUrl = exports.getUrl = function getUrl(template) {
	  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	
	  (0, _keys2.default)(params).forEach(function (key) {
	    template = template.replace("{" + key + "}", params[key]);
	  });
	  return template;
	};

/***/ }),

/***/ 181:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.authClient = undefined;
	
	var _promise = __webpack_require__(81);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _classCallCheck2 = __webpack_require__(82);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(83);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(59);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(51);
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _constants2 = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function parseJwt(token) {
	  var base64Url = token.split(".")[1];
	  var base64 = base64Url.replace(/-/g, "+").replace(/_/g, "/");
	  return JSON.parse(window.atob(base64));
	}
	
	function getQueryParam(name, url) {
	  if (!url) url = window.location.href;
	  name = name.replace(/[[\]]/g, "\\$&");
	  regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)");
	  results = regex.exec(url);
	  if (!results) return null;
	  if (!results[2]) return "";
	  return decodeURIComponent(results[2]);
	}
	
	function getToken(tokenName) {
	  return localStorage.getItem(tokenName) || undefined;
	}
	
	function setToken(tokenName, tokenValue) {
	  localStorage.removeItem(tokenName, "");
	  if (!tokenValue) return;
	  localStorage.setItem(tokenName, tokenValue);
	}
	
	var reactiveTokensStore = new _vue2.default({
	  data: function data() {
	    return {
	      $accessToken: getToken("jwt_access_token"),
	      $refreshToken: getToken("jwt_refresh_token")
	    };
	  },
	  computed: {
	    accessToken: {
	      get: function get() {
	        return this._data.$accessToken;
	      },
	      set: function set(tokenValue) {
	        this._data.$accessToken = tokenValue;
	        setToken("jwt_access_token", tokenValue);
	      }
	    },
	    refreshToken: {
	      get: function get() {
	        return this._data.$refreshToken;
	      },
	      set: function set(tokenValue) {
	        this._data.$refreshToken = tokenValue;
	        setToken("jwt_refresh_token", tokenValue);
	      }
	    }
	  }
	});
	
	var AuthClient = function () {
	  function AuthClient() {
	    (0, _classCallCheck3.default)(this, AuthClient);
	  }
	
	  (0, _createClass3.default)(AuthClient, [{
	    key: "login",
	    value: function login(email, password) {
	      return _axios2.default.post((0, _constants2.getUrl)(_constants.URL.POST_LOGIN), {
	        email: email,
	        password: password
	      }).then(function (resp) {
	        reactiveTokensStore.accessToken = resp.data.access_token;
	        reactiveTokensStore.refreshToken = resp.data.refresh_token;
	        return resp;
	      });
	    }
	  }, {
	    key: "setAccessToken",
	    value: function setAccessToken(token) {
	      reactiveTokensStore.accessToken = token;
	    }
	  }, {
	    key: "setRefreshToken",
	    value: function setRefreshToken(token) {
	      reactiveTokensStore.refreshToken = token;
	    }
	  }, {
	    key: "forgotPassword",
	    value: function forgotPassword(email) {
	      return _axios2.default.post((0, _constants2.getUrl)(_constants.URL.POST_FORGOT_PASSWORD), {
	        email: email,
	        recaptcha: recaptcha
	      });
	    }
	  }, {
	    key: "resetPassword",
	    value: function resetPassword(password) {
	      return _axios2.default.post((0, _constants2.getUrl)(_constants.URL.POST_RESET_PASSWORD), {
	        userId: this.passwordResetUserId,
	        code: this.passwordResetToken,
	        password: password
	      });
	    }
	  }, {
	    key: "logout",
	    value: function logout() {
	      return new _promise2.default(function (resolve, reject) {
	        reactiveTokensStore.accessToken = undefined;
	        reactiveTokensStore.refreshToken = undefined;
	        resolve();
	      });
	    }
	  }, {
	    key: "refreshTokens",
	    value: function refreshTokens(error) {
	      var _this = this;
	
	      if (this.__refreshPromise) return this.__refreshPromise;
	      if (!reactiveTokensStore.refreshToken) return _promise2.default.reject(error);
	      this.__refreshPromise = _axios2.default.post((0, _constants2.getUrl)(_constants.URL.POST_JWT_REFRESH), {
	        refreshToken: reactiveTokensStore.refreshToken
	      }, {
	        __jwt_retry: true
	      }).then(function (resp) {
	        _this.__refreshPromise = undefined;
	        reactiveTokensStore.accessToken = resp.data.access_token;
	        reactiveTokensStore.refreshToken = resp.data.refresh_token;
	        return resp;
	      }).catch(function (error) {
	        _this.__refreshPromise = undefined;
	        if (error.response && error.response.status === 401) {
	          return _this.logout().then(function () {
	            if (_this.unauthorizedCallback) _this.unauthorizedCallback();else throw error;
	          });
	        }
	        throw error;
	      });
	      return this.__refreshPromise;
	    }
	  }, {
	    key: "getEmail",
	    value: function getEmail() {
	      if (this.authenticated) {
	        return parseJwt(reactiveTokensStore.accessToken).sub;
	      } else {
	        return "";
	      }
	    }
	  }, {
	    key: "getDetails",
	    value: function getDetails() {
	      return _axios2.default.get((0, _constants2.getUrl)(_constants.URL.GET_ACCOUNT_DETAILS));
	    }
	  }, {
	    key: "addAxiosInterceptor",
	    value: function addAxiosInterceptor(unauthorizedCallback) {
	      var _this2 = this;
	
	      this.unauthorizedCallback = unauthorizedCallback;
	      _axios2.default.interceptors.request.use(function (config) {
	        if (!config.__jwt_retry) {
	          config.headers["Authorization"] = reactiveTokensStore.accessToken ? "Bearer " + reactiveTokensStore.accessToken : "";
	        }
	        return config;
	      });
	      _axios2.default.interceptors.response.use(undefined, function (error) {
	        var originalRequest = error.config;
	        if (error.response && error.response.status === 401 && !originalRequest.__jwt_retry) {
	          originalRequest.__jwt_retry = true;
	          return _this2.refreshTokens(error).then(function (resp) {
	            originalRequest.headers["Authorization"] = reactiveTokensStore.accessToken ? "Bearer " + reactiveTokensStore.accessToken : "";
	            return (0, _axios2.default)(originalRequest);
	          });
	        }
	        return _promise2.default.reject(error);
	      });
	    }
	  }, {
	    key: "passwordResetUserId",
	    get: function get() {
	      return getQueryParam("passwordResetUserId");
	    }
	  }, {
	    key: "passwordResetToken",
	    get: function get() {
	      return getQueryParam("passwordResetToken");
	    }
	  }, {
	    key: "authenticated",
	    get: function get() {
	      return !!reactiveTokensStore.accessToken && !!reactiveTokensStore.refreshToken;
	    }
	  }]);
	  return AuthClient;
	}();
	
	var authClient = exports.authClient = new AuthClient();

/***/ }),

/***/ 182:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.devicesClient = undefined;
	
	var _classCallCheck2 = __webpack_require__(82);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(83);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(59);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var DevicesClient = function () {
	  function DevicesClient() {
	    (0, _classCallCheck3.default)(this, DevicesClient);
	  }
	
	  (0, _createClass3.default)(DevicesClient, [{
	    key: "getDevices",
	    value: function getDevices(pageNum, pageSize) {
	      return _axios2.default.get((0, _constants.getUrl)(_constants.URL.GET_DEVICES_LIST), {
	        params: {
	          pageNum: pageNum,
	          pageSize: pageSize
	        }
	      });
	    }
	  }, {
	    key: "searchDevices",
	    value: function searchDevices(q, pageNum, pageSize) {
	      return _axios2.default.get((0, _constants.getUrl)(_constants.URL.GET_DEVICES_SEARCH), {
	        params: {
	          q: q,
	          pageNum: pageNum,
	          pageSize: pageSize
	        }
	      });
	    }
	  }, {
	    key: "getDevice",
	    value: function getDevice(serial) {
	      return _axios2.default.get((0, _constants.getUrl)(_constants.URL.GET_DEVICE, {
	        serial: serial
	      }));
	    }
	  }, {
	    key: "getStatuses",
	    value: function getStatuses(serials) {
	      return _axios2.default.post(_constants.URL.GET_DEVICE_STATUS, serials);
	    }
	  }, {
	    key: "putDevice",
	    value: function putDevice(serial, device) {
	      return _axios2.default.put((0, _constants.getUrl)(_constants.URL.PUT_DEVICE, {
	        serial: serial
	      }), device);
	    }
	  }, {
	    key: "postDevice",
	    value: function postDevice(device) {
	      return _axios2.default.post((0, _constants.getUrl)(_constants.URL.POST_DEVICE), device);
	    }
	  }, {
	    key: "deleteDevice",
	    value: function deleteDevice(serial) {
	      return _axios2.default.delete((0, _constants.getUrl)(_constants.URL.DELETE_DEVICE, {
	        serial: serial
	      }));
	    }
	  }, {
	    key: "restoreDevice",
	    value: function restoreDevice(serial) {
	      return _axios2.default.patch((0, _constants.getUrl)(_constants.URL.PATCH_DEVICE_RESTORE, {
	        serial: serial
	      }));
	    }
	  }, {
	    key: "xmlSend",
	    value: function xmlSend(serial) {
	      return _axios2.default.post((0, _constants.getUrl)(_constants.URL.GET_XML_FILE, {
	        serial: serial
	      }));
	    }
	  }, {
	    key: "getContent",
	    value: function getContent(serial, page, pageSize) {
	      return _axios2.default.get((0, _constants.getUrl)(_constants.URL.GET_DEVICE_CONTENT, {
	        serial: serial
	      }), {
	        params: {
	          pageNum: page,
	          pageSize: pageSize
	        }
	      });
	    }
	  }]);
	  return DevicesClient;
	}();
	
	var devicesClient = exports.devicesClient = new DevicesClient();

/***/ }),

/***/ 272:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.videoClient = undefined;
	
	var _classCallCheck2 = __webpack_require__(82);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(83);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(59);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var VideoClient = function () {
	  function VideoClient() {
	    (0, _classCallCheck3.default)(this, VideoClient);
	  }
	
	  (0, _createClass3.default)(VideoClient, [{
	    key: "search",
	    value: function search(deviceSerial, from, to) {
	      return _axios2.default.post((0, _constants.getUrl)(_constants.URL.POST_VIDEO_SEARCH), {
	        deviceSerial: deviceSerial,
	        from: from,
	        to: to
	      });
	    }
	  }, {
	    key: "download",
	    value: function download(deviceSerial, files) {
	      return _axios2.default.post((0, _constants.getUrl)(_constants.URL.POST_VIDEO_DOWNLOAD), {
	        deviceSerial: deviceSerial,
	        files: files
	      });
	    }
	  }, {
	    key: "requestLiveStream",
	    value: function requestLiveStream(deviceSerial, channels) {
	      return _axios2.default.post((0, _constants.getUrl)(_constants.URL.POST_VIDEO_LIVE), {
	        deviceSerial: deviceSerial,
	        channels: channels
	      });
	    }
	  }]);
	  return VideoClient;
	}();
	
	var videoClient = exports.videoClient = new VideoClient();

/***/ }),

/***/ 654:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.customersClient = undefined;
	
	var _classCallCheck2 = __webpack_require__(82);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(83);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(59);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CustomersClient = function () {
	  function CustomersClient() {
	    (0, _classCallCheck3.default)(this, CustomersClient);
	  }
	
	  (0, _createClass3.default)(CustomersClient, [{
	    key: "getCustomers",
	    value: function getCustomers(pageNum, pageSize) {
	      return _axios2.default.get((0, _constants.getUrl)(_constants.URL.GET_CUSTOMERS_LIST), {
	        params: {
	          pageNum: pageNum,
	          pageSize: pageSize
	        }
	      });
	    }
	  }, {
	    key: "getCustomer",
	    value: function getCustomer(id) {
	      return _axios2.default.get((0, _constants.getUrl)(_constants.URL.GET_CUSTOMER, {
	        id: id
	      }));
	    }
	  }, {
	    key: "postCustomer",
	    value: function postCustomer(customer) {
	      return _axios2.default.post((0, _constants.getUrl)(_constants.URL.POST_CUSTOMER), customer);
	    }
	  }, {
	    key: "putCustomer",
	    value: function putCustomer(id, customer) {
	      return _axios2.default.put((0, _constants.getUrl)(_constants.URL.PUT_CUSTOMER, {
	        id: id
	      }), customer);
	    }
	  }, {
	    key: "putCustomerSecretKey",
	    value: function putCustomerSecretKey(id) {
	      return _axios2.default.put((0, _constants.getUrl)(_constants.URL.PUT_CUSTOMER_SECRET_KEY, {
	        id: id
	      }));
	    }
	  }, {
	    key: "deleteCustomer",
	    value: function deleteCustomer(id) {
	      return _axios2.default.delete((0, _constants.getUrl)(_constants.URL.DELETE_CUSTOMER, {
	        id: id
	      }));
	    }
	  }]);
	  return CustomersClient;
	}();
	
	var customersClient = exports.customersClient = new CustomersClient();

/***/ }),

/***/ 655:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.snapshotClient = undefined;
	
	var _classCallCheck2 = __webpack_require__(82);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(83);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(59);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var SnapshotClient = function () {
	  function SnapshotClient() {
	    (0, _classCallCheck3.default)(this, SnapshotClient);
	  }
	
	  (0, _createClass3.default)(SnapshotClient, [{
	    key: "makeSnapshot",
	    value: function makeSnapshot(deviceSerial, channels) {
	      return _axios2.default.post((0, _constants.getUrl)(_constants.URL.POST_SNAPSHOT), {
	        deviceSerial: deviceSerial,
	        channels: channels
	      });
	    }
	  }]);
	  return SnapshotClient;
	}();
	
	var snapshotClient = exports.snapshotClient = new SnapshotClient();

/***/ }),

/***/ 656:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.usersClient = undefined;
	
	var _classCallCheck2 = __webpack_require__(82);
	
	var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);
	
	var _createClass2 = __webpack_require__(83);
	
	var _createClass3 = _interopRequireDefault(_createClass2);
	
	var _axios = __webpack_require__(59);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var UsersClient = function () {
	  function UsersClient() {
	    (0, _classCallCheck3.default)(this, UsersClient);
	  }
	
	  (0, _createClass3.default)(UsersClient, [{
	    key: 'getUsers',
	    value: function getUsers(pageNum, pageSize) {
	      return _axios2.default.get((0, _constants.getUrl)(_constants.URL.GET_USERS_LIST), {
	        params: {
	          pageNum: pageNum,
	          pageSize: pageSize
	        }
	      });
	    }
	  }, {
	    key: 'getRoles',
	    value: function getRoles() {
	      return _axios2.default.get((0, _constants.getUrl)(_constants.URL.GET_ROLES_LIST));
	    }
	  }, {
	    key: 'getUser',
	    value: function getUser(id) {
	      return _axios2.default.get((0, _constants.getUrl)(_constants.URL.GET_USER, {
	        id: id
	      }));
	    }
	  }, {
	    key: 'postUser',
	    value: function postUser(customer) {
	      return _axios2.default.post((0, _constants.getUrl)(_constants.URL.POST_USER), customer);
	    }
	  }, {
	    key: 'putUser',
	    value: function putUser(id, customer) {
	      return _axios2.default.put((0, _constants.getUrl)(_constants.URL.PUT_USER, {
	        id: id
	      }), customer);
	    }
	  }, {
	    key: 'deleteUser',
	    value: function deleteUser(id) {
	      return _axios2.default.delete((0, _constants.getUrl)(_constants.URL.DELETE_USER, {
	        id: id
	      }));
	    }
	  }]);
	  return UsersClient;
	}();
	
	var usersClient = exports.usersClient = new UsersClient();

/***/ }),

/***/ 657:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _auth = __webpack_require__(181);
	
	var _Dashboard = __webpack_require__(1108);
	
	var _Dashboard2 = _interopRequireDefault(_Dashboard);
	
	var _Index = __webpack_require__(1119);
	
	var _Index2 = _interopRequireDefault(_Index);
	
	var _Index3 = __webpack_require__(1122);
	
	var _Index4 = _interopRequireDefault(_Index3);
	
	var _Stream = __webpack_require__(1126);
	
	var _Stream2 = _interopRequireDefault(_Stream);
	
	var _Add = __webpack_require__(1120);
	
	var _Add2 = _interopRequireDefault(_Add);
	
	var _Edit = __webpack_require__(1121);
	
	var _Edit2 = _interopRequireDefault(_Edit);
	
	var _View = __webpack_require__(1128);
	
	var _View2 = _interopRequireDefault(_View);
	
	var _Index5 = __webpack_require__(1114);
	
	var _Index6 = _interopRequireDefault(_Index5);
	
	var _Add3 = __webpack_require__(1112);
	
	var _Add4 = _interopRequireDefault(_Add3);
	
	var _Edit3 = __webpack_require__(1113);
	
	var _Edit4 = _interopRequireDefault(_Edit3);
	
	var _View3 = __webpack_require__(1115);
	
	var _View4 = _interopRequireDefault(_View3);
	
	var _Index7 = __webpack_require__(1132);
	
	var _Index8 = _interopRequireDefault(_Index7);
	
	var _Add5 = __webpack_require__(1130);
	
	var _Add6 = _interopRequireDefault(_Add5);
	
	var _Edit5 = __webpack_require__(1131);
	
	var _Edit6 = _interopRequireDefault(_Edit5);
	
	var _View5 = __webpack_require__(1133);
	
	var _View6 = _interopRequireDefault(_View5);
	
	var _ = __webpack_require__(1117);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(1116);
	
	var _4 = _interopRequireDefault(_3);
	
	var _DashboardSecond = __webpack_require__(1118);
	
	var _DashboardSecond2 = _interopRequireDefault(_DashboardSecond);
	
	var _Login = __webpack_require__(1109);
	
	var _Login2 = _interopRequireDefault(_Login);
	
	var _vueRouter = __webpack_require__(514);
	
	var _vueRouter2 = _interopRequireDefault(_vueRouter);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (store) {
	  var routes = [{
	    path: "/",
	    component: _Dashboard2.default,
	    meta: {
	      authorize: true
	    },
	    children: [{
	      path: "",
	      name: "dashboard",
	      component: _Index2.default
	    }, {
	      path: "/devices",
	      component: {
	        render: function render(c) {
	          return c("router-view");
	        }
	      },
	      children: [{
	        path: "",
	        name: "devices",
	        component: _Index4.default
	      }, {
	        path: "add",
	        name: "addDevice",
	        component: _Add2.default
	      }, {
	        path: ":serial/edit",
	        name: "editDevice",
	        component: _Edit2.default,
	        props: true
	      }, {
	        path: ":serial/view",
	        name: "viewDevice",
	        component: _View2.default,
	        props: true
	      }, {
	        path: ":serial/stream",
	        name: "streamDevice",
	        component: _Stream2.default,
	        props: true
	      }]
	    }, {
	      path: "/customers",
	      component: {
	        render: function render(c) {
	          return c("router-view");
	        }
	      },
	      meta: {
	        isAdmin: true
	      },
	      children: [{
	        path: "",
	        name: "customers",
	        component: _Index6.default
	      }, {
	        path: "add",
	        name: "addCustomer",
	        component: _Add4.default
	      }, {
	        path: ":id/edit",
	        name: "editCustomer",
	        component: _Edit4.default,
	        props: true
	      }, {
	        path: ":id/view",
	        name: "viewCustomer",
	        component: _View4.default,
	        props: true
	      }]
	    }, {
	      path: "/users",
	      component: {
	        render: function render(c) {
	          return c("router-view");
	        }
	      },
	      meta: {
	        isAdmin: true
	      },
	      children: [{
	        path: "",
	        name: "users",
	        component: _Index8.default
	      }, {
	        path: "add",
	        name: "addUser",
	        component: _Add6.default
	      }, {
	        path: ":id/edit",
	        name: "editUser",
	        component: _Edit6.default,
	        props: true
	      }, {
	        path: ":id/view",
	        name: "viewUser",
	        component: _View6.default,
	        props: true
	      }]
	    }, {
	      path: "dashboard-second",
	      name: "dashboard-second",
	      component: _DashboardSecond2.default
	    }]
	  }, {
	    path: "/login",
	    name: "login",
	    component: _Login2.default,
	    props: function props(route) {
	      return {
	        to: route.query.to
	      };
	    }
	  }, {
	    path: "/logout",
	    name: "logout"
	  }, {
	    path: "/404",
	    name: "404",
	    component: _2.default
	  }, {
	    path: "/403",
	    name: "403",
	    component: _4.default
	  }, {
	    path: "*",
	    name: "404Default",
	    component: _2.default
	  }];
	
	  var router = new _vueRouter2.default({
	    routes: routes,
	    mode: "history",
	    linkActiveClass: "open active",
	    scrollBehavior: function scrollBehavior(to, from, savedPosition) {
	      return savedPosition || {
	        x: 0,
	        y: 0
	      };
	    }
	  });
	  router.beforeEach(function (to, from, next) {
	    if (to.name === "logout") {
	      _auth.authClient.logout().then(next);
	      store.dispatch("reset", { store: store });
	    } else next();
	  });
	  router.beforeEach(function (to, from, next) {
	    if (to.matched.some(function (m) {
	      return m.meta.authorize;
	    }) && !_auth.authClient.authenticated) {
	      next({
	        name: "login",
	        query: {
	          to: to.fullPath
	        }
	      });
	    } else next();
	  });
	  router.beforeEach(function (to, from, next) {
	    if (to.matched.some(function (m) {
	      return m.meta.isAdmin;
	    }) && !store.getters["account/isAdmin"]) {
	      next({
	        name: "403"
	      });
	    } else next();
	  });
	  router.beforeEach(function (to, from, next) {
	    if (to.name === "passwordChange" && (!_auth.authClient.passwordResetToken || !_auth.authClient.passwordResetUserId)) {
	      next({
	        name: "dashboard"
	      });
	    } else next();
	  });
	  router.afterEach(function (to, from) {
	    if (to.name === "logout") {
	      router.replace({
	        name: "dashboard"
	      });
	    }
	
	    window.scrollTo(0, 0);
	    document.querySelector("body").classList.remove("popup-opened");
	  });
	  _auth.authClient.addAxiosInterceptor(function () {
	    var current = router.currentRoute;
	    var to = current.name === "login" ? current.query.to : current.fullPath;
	    router.push({
	      name: "login",
	      query: to ? {
	        to: to
	      } : {}
	    });
	  });
	  return router;
	};

/***/ }),

/***/ 658:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(52);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _auth = __webpack_require__(181);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var ROLE_ADMIN = 'ROLE_ADMIN';
	var initialState = function initialState() {
	  return {
	    email: undefined,
	    roles: [],
	    userName: undefined,
	    promises: {
	      detailsFetchPromise: undefined
	    }
	  };
	};
	
	exports.default = {
	  namespaced: true,
	  state: initialState(),
	  getters: {
	    user: function user(state) {
	      var email = state.email,
	          userName = state.userName;
	
	      return {
	        email: email,
	        userName: userName
	      };
	    },
	    authenticated: function authenticated(_) {
	      return _auth.authClient.authenticated;
	    },
	    isAdmin: function isAdmin(state) {
	      return state.roles.some(function (x) {
	        return x === ROLE_ADMIN;
	      });
	    },
	    detailsFetching: function detailsFetching(state) {
	      return state.promises.detailsFetchPromise !== undefined;
	    }
	  },
	  mutations: {
	    reset: function reset(state) {
	      var initial = initialState();
	      (0, _keys2.default)(initial).forEach(function (k) {
	        state[k] = initial[k];
	      });
	    },
	    details: function details(state, _ref) {
	      var userName = _ref.userName,
	          email = _ref.email,
	          roles = _ref.roles;
	
	      state.userName = userName;
	      state.email = email;
	      state.roles = roles;
	    },
	    detailsFetchPromise: function detailsFetchPromise(state, promise) {
	      state.promises.detailsFetchPromise = promise;
	    }
	  },
	  actions: {
	    fetchDetails: function fetchDetails(ctx) {
	      if (ctx.getters.detailsFetching) return;
	      var promise = _auth.authClient.getDetails().then(function (resp) {
	        ctx.commit('detailsFetchPromise', undefined);
	        ctx.commit('details', resp.data);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit('detailsFetchPromise', undefined);
	        throw error;
	      });
	      ctx.commit('detailsFetchPromise', promise);
	      return promise;
	    }
	  }
	};

/***/ }),

/***/ 659:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(52);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _customers = __webpack_require__(654);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = function initialState() {
	  return {
	    customers: [],
	    pagination: {
	      pageNum: 1,
	      pageSize: 10,
	      totalCount: 0,
	      rowsPerPageItems: [10, 20, 30, 40, 50, 100]
	    },
	    promises: {
	      customersFetchPromise: undefined,
	      customersSavePromise: undefined,
	      customersDeletePromise: undefined
	    }
	  };
	};
	
	exports.default = {
	  namespaced: true,
	  state: initialState(),
	  getters: {
	    list: function list(state) {
	      return state.customers;
	    },
	    customersFetching: function customersFetching(state) {
	      return state.promises.customersFetchPromise !== undefined;
	    },
	    customersSaving: function customersSaving(state) {
	      return state.promises.customersSavePromise !== undefined;
	    },
	    customerDeleting: function customerDeleting(state) {
	      return state.promises.customersDeletePromise !== undefined;
	    },
	    pagination: function pagination(state) {
	      return state.pagination;
	    }
	  },
	  mutations: {
	    reset: function reset(state) {
	      var initial = initialState();
	      (0, _keys2.default)(initial).forEach(function (k) {
	        state[k] = initial[k];
	      });
	    },
	    setCustomers: function setCustomers(state, _ref) {
	      var customers = _ref.customers,
	          totalCount = _ref.totalCount;
	
	      state.customers = customers;
	      _vue2.default.set(state.pagination, "totalCount", totalCount);
	    },
	    setPagination: function setPagination(state, payload) {
	      state.pagination = payload;
	    },
	    deleteCustomerById: function deleteCustomerById(state, customerId) {
	      var index = state.customers.findIndex(function (x) {
	        return x.id === customerId;
	      });
	      if (index >= 0) {
	        state.customers.splice(index, 1);
	      } else throw Error("Wrong customer id: " + customerId);
	    },
	    customersFetchPromise: function customersFetchPromise(state, promise) {
	      state.promises.customersFetchPromise = promise;
	    },
	    customersSavePromise: function customersSavePromise(state, promise) {
	      state.promises.customersSavePromise = promise;
	    },
	    customersDeletePromise: function customersDeletePromise(state, promise) {
	      state.promises.customersDeletePromise = promise;
	    }
	  },
	  actions: {
	    getCustomer: function getCustomer(ctx, id) {
	      if (ctx.getters.customersFetching) return;
	      var promise = _customers.customersClient.getCustomer(id).then(function (resp) {
	        ctx.commit("customersFetchPromise", undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("customersFetchPromise", undefined);
	        throw error;
	      });
	      ctx.commit("customersFetchPromise", promise);
	      return promise;
	    },
	    addCustomer: function addCustomer(ctx, customer) {
	      if (ctx.getters.customersSaving) return;
	      var promise = _customers.customersClient.postCustomer(customer).then(function (resp) {
	        ctx.commit("customersSavePromise", undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("customersSavePromise", undefined);
	        throw error;
	      });
	      ctx.commit("customersSavePromise", promise);
	      return promise;
	    },
	    addCustomerSecretKey: function addCustomerSecretKey(ctx, _ref2) {
	      var id = _ref2.id;
	
	      if (ctx.getters.customersSaving) return;
	      var promise = _customers.customersClient.putCustomerSecretKey(id).then(function (resp) {
	        ctx.commit("customersSavePromise", undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("customersSavePromise", undefined);
	        throw error;
	      });
	      ctx.commit("customersSavePromise", promise);
	      return promise;
	    },
	    saveCustomer: function saveCustomer(ctx, _ref3) {
	      var id = _ref3.id,
	          customer = _ref3.customer;
	
	      if (ctx.getters.customersSaving) return;
	      var promise = _customers.customersClient.putCustomer(id, customer).then(function (resp) {
	        ctx.commit("customersSavePromise", undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("customersSavePromise", undefined);
	        throw error;
	      });
	      ctx.commit("customersSavePromise", promise);
	      return promise;
	    },
	    fetchCustomers: function fetchCustomers(ctx) {
	      if (ctx.getters.customersFetching) return;
	      var _ctx$state$pagination = ctx.state.pagination,
	          pageNum = _ctx$state$pagination.pageNum,
	          pageSize = _ctx$state$pagination.pageSize;
	
	      var promise = _customers.customersClient.getCustomers(pageNum, pageSize).then(function (resp) {
	        var _resp$data = resp.data,
	            customers = _resp$data.customers,
	            totalCount = _resp$data.totalCount;
	
	        ctx.commit("customersFetchPromise", undefined);
	        ctx.commit("setCustomers", {
	          customers: customers,
	          totalCount: totalCount
	        });
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("customersFetchPromise", undefined);
	        throw error;
	      });
	      ctx.commit("customersFetchPromise", promise);
	      return promise;
	    },
	    deleteCustomer: function deleteCustomer(ctx, _ref4) {
	      var id = _ref4.id;
	
	      if (ctx.getters.customerDeleting) return;
	      var promise = _customers.customersClient.deleteCustomer(id).then(function (resp) {
	        ctx.commit("customersDeletePromise", undefined);
	        ctx.commit("deleteDustomerById", id);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("customersDeletePromise", undefined);
	        throw error;
	      });
	      ctx.commit("customersDeletePromise", promise);
	      return promise;
	    }
	  }
	};

/***/ }),

/***/ 660:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(52);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _devices = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = function initialState() {
	  return {
	    devices: [],
	    activeDevices: [],
	    search: "",
	    pagination: {
	      pageNum: 1,
	      pageSize: 10,
	      totalCount: 0,
	      rowsPerPageItems: [2, 10, 20, 30, 40, 50, 100]
	    },
	    promises: {
	      deviceStatusFetchPromise: undefined,
	      devicesFetchPromise: undefined,
	      devicesDeletePromise: undefined,
	      devicesSavePromise: undefined
	    }
	  };
	};
	
	exports.default = {
	  namespaced: true,
	  state: initialState(),
	  getters: {
	    list: function list(state) {
	      return state.devices;
	    },
	    activeDevices: function activeDevices(state) {
	      return state.activeDevices;
	    },
	    devicesFetching: function devicesFetching(state) {
	      return state.promises.devicesFetchPromise !== undefined;
	    },
	    devicesSaving: function devicesSaving(state) {
	      return state.promises.devicesFetchPromise !== undefined;
	    },
	    deviceDeleting: function deviceDeleting(state) {
	      return state.promises.devicesSavePromise !== undefined;
	    },
	    pagination: function pagination(state) {
	      return state.pagination;
	    },
	    search: function search(state) {
	      return state.search;
	    }
	  },
	  mutations: {
	    reset: function reset(state) {
	      var initial = initialState();
	      (0, _keys2.default)(initial).forEach(function (k) {
	        state[k] = initial[k];
	      });
	    },
	    setDevices: function setDevices(state, _ref) {
	      var devices = _ref.devices,
	          totalCount = _ref.totalCount;
	
	      state.devices = devices;
	      state.pagination.totalCount = totalCount;
	    },
	    setPagination: function setPagination(state, payload) {
	      state.pagination = payload;
	    },
	    setSearch: function setSearch(state, payload) {
	      state.search = payload;
	    },
	    setActiveDevices: function setActiveDevices(state, devices) {
	      state.activeDevices = devices;
	    },
	    deleteDeviceBySerial: function deleteDeviceBySerial(state, serial) {
	      var index = state.devices.findIndex(function (x) {
	        return x.serial === serial;
	      });
	      if (index >= 0) {
	        state.devices.splice(index, 1);
	      } else throw Error("Wrong device serial: " + serial);
	    },
	    devicesFetchPromise: function devicesFetchPromise(state, promise) {
	      state.promises.devicesFetchPromise = promise;
	    },
	    devicesSavePromise: function devicesSavePromise(state, promise) {
	      state.promises.devicesSavePromise = promise;
	    },
	    devicesDeletePromise: function devicesDeletePromise(state, promise) {
	      state.promises.devicesDeletePromise = promise;
	    },
	    deviceStatusFetchPromise: function deviceStatusFetchPromise(state, promise) {
	      state.promises.deviceStatusFetchPromise = promise;
	    },
	    videoListFetchingPromise: function videoListFetchingPromise(state, promise) {
	      state.promises.videoListFetchingPromise = promise;
	    }
	  },
	  actions: {
	    getDevice: function getDevice(ctx, serial) {
	      if (ctx.getters.devicesFetching) return;
	      var promise = _devices.devicesClient.getDevice(serial).then(function (resp) {
	        ctx.commit("devicesFetchPromise", undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("devicesFetchPromise", undefined);
	        throw error;
	      });
	      ctx.commit("devicesFetchPromise", promise);
	      return promise;
	    },
	    addDevice: function addDevice(ctx, device) {
	      if (ctx.getters.devicesSaving) return;
	      var promise = _devices.devicesClient.postDevice(device).then(function (resp) {
	        ctx.commit("devicesSavePromise", undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("devicesSavePromise", undefined);
	        throw error;
	      });
	      ctx.commit("devicesSavePromise", promise);
	      return promise;
	    },
	    saveDevice: function saveDevice(ctx, _ref2) {
	      var serial = _ref2.serial,
	          device = _ref2.device;
	
	      if (ctx.getters.devicesSaving) return;
	      var promise = _devices.devicesClient.putDevice(serial, device).then(function (resp) {
	        ctx.commit("devicesSavePromise", undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("devicesSavePromise", undefined);
	        throw error;
	      });
	      ctx.commit("devicesSavePromise", promise);
	      return promise;
	    },
	    fetchDevices: function fetchDevices(ctx) {
	      if (ctx.getters.devicesFetching) return;
	      var _ctx$state$pagination = ctx.state.pagination,
	          pageNum = _ctx$state$pagination.pageNum,
	          pageSize = _ctx$state$pagination.pageSize;
	
	      var promise = _devices.devicesClient.getDevices(pageNum, pageSize).then(function (resp) {
	        var _resp$data = resp.data,
	            devices = _resp$data.devices,
	            totalCount = _resp$data.totalCount;
	
	        ctx.commit("devicesFetchPromise", undefined);
	        ctx.commit("setDevices", {
	          devices: devices,
	          totalCount: totalCount
	        });
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("devicesFetchPromise", undefined);
	        throw error;
	      });
	      ctx.commit("devicesFetchPromise", promise);
	      return promise;
	    },
	    searchDevices: function searchDevices(ctx) {
	
	      if (ctx.getters.devicesFetching) return;
	      var _ctx$state$pagination2 = ctx.state.pagination,
	          pageNum = _ctx$state$pagination2.pageNum,
	          pageSize = _ctx$state$pagination2.pageSize;
	
	      var q = ctx.state.search;
	      var promise = _devices.devicesClient.searchDevices(q, pageNum, pageSize).then(function (resp) {
	        var _resp$data2 = resp.data,
	            devices = _resp$data2.devices,
	            totalCount = _resp$data2.totalCount;
	
	        ctx.commit("devicesFetchPromise", undefined);
	        ctx.commit("setDevices", {
	          devices: devices,
	          totalCount: totalCount
	        });
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("devicesFetchPromise", undefined);
	        throw error;
	      });
	      ctx.commit("devicesFetchPromise", promise);
	      return promise;
	    },
	    fetchActiveDevices: function fetchActiveDevices(ctx) {
	      if (ctx.getters.list.length === 0) return;
	      var promise = _devices.devicesClient.getStatuses(ctx.getters.list.map(function (x) {
	        return x.serial;
	      })).then(function (resp) {
	        var data = resp.data;
	
	        var activeDevices = (0, _keys2.default)(data).filter(function (x) {
	          return data[x] === 'ONLINE';
	        });
	        ctx.commit("deviceStatusFetchPromise", undefined);
	        ctx.commit("setActiveDevices", activeDevices);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("deviceStatusFetchPromise", undefined);
	        throw error;
	      });
	      ctx.commit("deviceStatusFetchPromise", promise);
	      return promise;
	    },
	    deleteDevice: function deleteDevice(ctx, _ref3) {
	      var serial = _ref3.serial;
	
	      if (ctx.getters.deviceDeleting) return;
	      var promise = _devices.devicesClient.deleteDevice(serial).then(function (resp) {
	        ctx.commit("devicesDeletePromise", undefined);
	        ctx.commit("deleteDeviceBySerial", serial);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("devicesDeletePromise", undefined);
	        throw error;
	      });
	      ctx.commit("devicesDeletePromise", promise);
	      return promise;
	    },
	    restoreDevice: function restoreDevice(ctx, _ref4) {
	      var serial = _ref4.serial;
	
	      if (ctx.getters.deviceDeleting) return;
	      var promise = _devices.devicesClient.restoreDevice(serial).then(function (resp) {
	        ctx.commit("devicesDeletePromise", undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("devicesDeletePromise", undefined);
	        throw error;
	      });
	      ctx.commit("devicesDeletePromise", promise);
	      return promise;
	    },
	    xmlSend: function xmlSend(ctx, _ref5) {
	      var serial = _ref5.serial;
	
	      var promise = _devices.devicesClient.xmlSend(serial).then(function (resp) {
	        ctx.commit("devicesDeletePromise", undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit("devicesDeletePromise", undefined);
	        throw error;
	      });
	      ctx.commit("devicesDeletePromise", promise);
	      return promise;
	    }
	  }
	};

/***/ }),

/***/ 661:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(52);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _set = __webpack_require__(702);
	
	var _set2 = _interopRequireDefault(_set);
	
	var _accountModule = __webpack_require__(658);
	
	var _accountModule2 = _interopRequireDefault(_accountModule);
	
	var _devicesModule = __webpack_require__(660);
	
	var _devicesModule2 = _interopRequireDefault(_devicesModule);
	
	var _customersModule = __webpack_require__(659);
	
	var _customersModule2 = _interopRequireDefault(_customersModule);
	
	var _usersModule = __webpack_require__(662);
	
	var _usersModule2 = _interopRequireDefault(_usersModule);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  modules: {
	    account: _accountModule2.default,
	    devices: _devicesModule2.default,
	    customers: _customersModule2.default,
	    users: _usersModule2.default
	  },
	  state: {
	    device: '',
	    popups: new _set2.default(),
	    monthDictionary: ['Январь', 'Февраль', 'Март', 'Апрель', 'Май', 'Июнь', 'Июль', 'Август', 'Сентябрь', 'Октябрь', 'Ноябрь', 'Декабрь']
	  },
	  mutations: {
	    checkDevice: function checkDevice(state, device) {
	      state.device = device;
	    },
	    openPopup: function openPopup(state, uuid) {
	      state.popups.add(uuid);
	      if (document.body) document.body.classList.add('popup-opened');
	    },
	    closePopup: function closePopup(state, uuid) {
	      state.popups.delete(uuid);
	      if (state.popups.size === 0 && document.body) {
	        document.body.classList.remove('popup-opened');
	      }
	    },
	    setMonthDictionary: function setMonthDictionary(state, dictionary) {
	      state.monthDictionary = dictionary;
	    }
	  },
	  actions: {
	    reset: function reset(_ref, _ref2) {
	      var commit = _ref.commit;
	      var store = _ref2.store;
	
	      (0, _keys2.default)(store._modulesNamespaceMap).forEach(function (key) {
	        return commit(key + 'reset');
	      });
	    },
	    setMonthDictionaryHandler: function setMonthDictionaryHandler(context) {}
	  }
	};

/***/ }),

/***/ 662:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(52);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _vue = __webpack_require__(20);
	
	var _vue2 = _interopRequireDefault(_vue);
	
	var _users = __webpack_require__(656);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var initialState = function initialState() {
	  return {
	    users: [],
	    roles: [],
	    pagination: {
	      pageNum: 1,
	      pageSize: 10,
	      totalCount: 0,
	      rowsPerPageItems: [10, 20, 30, 40, 50, 100]
	    },
	    promises: {
	      rolesFetchPromise: undefined,
	      usersFetchPromise: undefined,
	      usersSavePromise: undefined,
	      usersDeletePromise: undefined
	    }
	  };
	};
	
	exports.default = {
	  namespaced: true,
	  state: initialState(),
	  getters: {
	    list: function list(state) {
	      return state.users;
	    },
	    roles: function roles(state) {
	      return state.roles;
	    },
	    usersFetching: function usersFetching(state) {
	      return state.promises.usersFetchPromise !== undefined;
	    },
	    userDeleting: function userDeleting(state) {
	      return state.promises.usersDeletePromise !== undefined;
	    },
	    usersSaving: function usersSaving(state) {
	      return state.promises.usersSavePromise !== undefined;
	    },
	    pagination: function pagination(state) {
	      return state.pagination;
	    }
	  },
	  mutations: {
	    reset: function reset(state) {
	      var initial = initialState();
	      (0, _keys2.default)(initial).forEach(function (k) {
	        state[k] = initial[k];
	      });
	    },
	    setUsers: function setUsers(state, _ref) {
	      var users = _ref.users,
	          totalCount = _ref.totalCount;
	
	      state.users = users;
	      _vue2.default.set(state.pagination, 'totalCount', totalCount);
	    },
	    setRoles: function setRoles(state, _ref2) {
	      var roles = _ref2.roles;
	
	      state.roles = roles;
	    },
	    setPagination: function setPagination(state, payload) {
	      state.pagination = payload;
	    },
	    deleteUserById: function deleteUserById(state, userId) {
	      var index = state.users.findIndex(function (x) {
	        return x.id === userId;
	      });
	      if (index >= 0) {
	        state.users.splice(index, 1);
	      } else throw Error('Wrong user id: ' + userId);
	    },
	    usersFetchPromise: function usersFetchPromise(state, promise) {
	      state.promises.usersFetchPromise = promise;
	    },
	    usersSavePromise: function usersSavePromise(state, promise) {
	      state.promises.usersSavePromise = promise;
	    },
	    usersDeletePromise: function usersDeletePromise(state, promise) {
	      state.promises.usersDeletePromise = promise;
	    },
	    rolesFetchPromise: function rolesFetchPromise(state, promise) {
	      state.promises.rolesFetchPromise = promise;
	    }
	  },
	  actions: {
	    fetchRoles: function fetchRoles(ctx) {
	      if (ctx.getters.usersFetchPromise) return;
	      var promise = _users.usersClient.getRoles().then(function (resp) {
	        var roles = resp.data.roles;
	
	        ctx.commit('rolesFetchPromise', undefined);
	        ctx.commit('setRoles', {
	          roles: roles
	        });
	        return resp;
	      }).catch(function (error) {
	        ctx.commit('rolesFetchPromise', undefined);
	        throw error;
	      });
	      ctx.commit('rolesFetchPromise', promise);
	      return promise;
	    },
	    getUser: function getUser(ctx, id) {
	      if (ctx.getters.usersFetching) return;
	      var promise = _users.usersClient.getUser(id).then(function (resp) {
	        ctx.commit('usersFetchPromise', undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit('usersFetchPromise', undefined);
	        throw error;
	      });
	      ctx.commit('usersFetchPromise', promise);
	      return promise;
	    },
	    addUser: function addUser(ctx, user) {
	      if (ctx.getters.usersSaving) return;
	      var promise = _users.usersClient.postUser(user).then(function (resp) {
	        ctx.commit('usersSavePromise', undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit('usersSavePromise', undefined);
	        throw error;
	      });
	      ctx.commit('usersSavePromise', promise);
	      return promise;
	    },
	    saveUser: function saveUser(ctx, _ref3) {
	      var id = _ref3.id,
	          user = _ref3.user;
	
	      if (ctx.getters.usersSaving) return;
	      var promise = _users.usersClient.putUser(id, user).then(function (resp) {
	        ctx.commit('usersSavePromise', undefined);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit('usersSavePromise', undefined);
	        throw error;
	      });
	      ctx.commit('usersSavePromise', promise);
	      return promise;
	    },
	    fetchUsers: function fetchUsers(ctx) {
	      if (ctx.getters.usersFetching) return;
	      var _ctx$state$pagination = ctx.state.pagination,
	          pageNum = _ctx$state$pagination.pageNum,
	          pageSize = _ctx$state$pagination.pageSize;
	
	      var promise = _users.usersClient.getUsers(pageNum, pageSize).then(function (resp) {
	        var _resp$data = resp.data,
	            users = _resp$data.users,
	            totalCount = _resp$data.totalCount;
	
	        ctx.commit('usersFetchPromise', undefined);
	        ctx.commit('setUsers', {
	          users: users,
	          totalCount: totalCount
	        });
	        return resp;
	      }).catch(function (error) {
	        ctx.commit('usersFetchPromise', undefined);
	        throw error;
	      });
	      ctx.commit('usersFetchPromise', promise);
	      return promise;
	    },
	    deleteUser: function deleteUser(ctx, _ref4) {
	      var id = _ref4.id;
	
	      if (ctx.getters.userDeleting) return;
	      var promise = _users.usersClient.deleteUser(id).then(function (resp) {
	        ctx.commit('usersDeletePromise', undefined);
	        ctx.commit('deleteUserById', id);
	        return resp;
	      }).catch(function (error) {
	        ctx.commit('usersDeletePromise', undefined);
	        throw error;
	      });
	      ctx.commit('usersDeletePromise', promise);
	      return promise;
	    }
	  }
	};

/***/ }),

/***/ 663:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'App'
	};

/***/ }),

/***/ 664:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _Sidebar = __webpack_require__(1139);
	
	var _Sidebar2 = _interopRequireDefault(_Sidebar);
	
	var _Header = __webpack_require__(1137);
	
	var _Header2 = _interopRequireDefault(_Header);
	
	var _Footer = __webpack_require__(1136);
	
	var _Footer2 = _interopRequireDefault(_Footer);
	
	var _ControlSidebar = __webpack_require__(1134);
	
	var _ControlSidebar2 = _interopRequireDefault(_ControlSidebar);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'Dashboard',
	  components: {
	    'app-sidebar': _Sidebar2.default,
	    'app-header': _Header2.default,
	    'app-footer': _Footer2.default,
	    'control-sidebar': _ControlSidebar2.default
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('account', ['fetchDetails'])),
	  created: function created() {
	    this.fetchDetails();
	  }
	};

/***/ }),

/***/ 665:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _regenerator = __webpack_require__(274);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _asyncToGenerator2 = __webpack_require__(273);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _auth = __webpack_require__(181);
	
	var _PasswordInput = __webpack_require__(1138);
	
	var _PasswordInput2 = _interopRequireDefault(_PasswordInput);
	
	var _DotsLoading = __webpack_require__(1135);
	
	var _DotsLoading2 = _interopRequireDefault(_DotsLoading);
	
	var _validators = __webpack_require__(1392);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    PasswordInput: _PasswordInput2.default,
	    DotsLoading: _DotsLoading2.default
	  },
	  data: function data() {
	    return {
	      inputs: {
	        email: undefined,
	        password: undefined
	      },
	      loginPromise: undefined,
	      serverErrors: ""
	    };
	  },
	
	  validations: {
	    inputs: {
	      email: {
	        required: _validators.required,
	        email: function email(v) {
	          return (v || "").includes(":as:") || (0, _validators.email)(v);
	        }
	      },
	      password: {
	        required: _validators.required
	      }
	    }
	  },
	  mounted: function mounted() {
	    localStorage.removeItem("jwt");
	    localStorage.removeItem("user");
	  },
	
	  methods: {
	    handleClose: function handleClose(done) {},
	    loginAsync: function loginAsync(email, password, recaptcha) {
	      var _this = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var response, message;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                _context.prev = 0;
	                _context.next = 3;
	                return _auth.authClient.login(email, password, recaptcha);
	
	              case 3:
	                return _context.abrupt("return", _context.sent);
	
	              case 6:
	                _context.prev = 6;
	                _context.t0 = _context["catch"](0);
	                response = _context.t0.response, message = _context.t0.message;
	
	
	                if (response && response.data) {
	                  _this.serverErrors = response.data.error || "";
	                } else _this.serverErrors = message;
	                throw _context.t0;
	
	              case 11:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this, [[0, 6]]);
	      }))();
	    },
	    formSubmit: function formSubmit() {
	      var _this2 = this;
	
	      if (this.loginPromise) return;
	      this.loginPromise = this.formSubmitAsync().then(function () {
	        return _this2.loginPromise = undefined;
	      }).catch(function (error) {
	        _this2.loginPromise = undefined;
	        throw error;
	      });
	    },
	    formSubmitAsync: function formSubmitAsync() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                _this3.$v.inputs.$touch();
	                _context2.next = 3;
	                return _this3.loginAsync(_this3.inputs.email, _this3.inputs.password, _this3.recaptcha);
	
	              case 3:
	                _this3.resetForm();
	                _this3.redirect();
	
	              case 5:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this3);
	      }))();
	    },
	    resetForm: function resetForm() {
	      this.inputs.email = undefined;
	      this.inputs.password = undefined;
	      this.serverErrors = "";
	
	      this.$v.$reset();
	    },
	    redirect: function redirect() {
	      this.$router.replace(this.to || { name: "dashboard" });
	    }
	  }
	};

/***/ }),

/***/ 666:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: "OnlineStatus",
	
	  props: {
	    status: {
	      type: Boolean,
	      default: null
	    }
	  }
	};

/***/ }),

/***/ 667:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _isFinite = __webpack_require__(697);
	
	var _isFinite2 = _interopRequireDefault(_isFinite);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vueTheMask = __webpack_require__(1174);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    directives: { mask: _vueTheMask.mask },
	    props: {
	        value: {
	            validator: function validator(x) {
	                return Array.isArray(x) && x.length === 2 && _moment2.default.isMoment(x[0]) && _moment2.default.isMoment(x[1]);
	            }
	        },
	        min: {
	            required: true,
	            validator: function validator(x) {
	                return _moment2.default.isMoment(x);
	            }
	        },
	        max: {
	            required: true,
	            validator: function validator(x) {
	                return _moment2.default.isMoment(x);
	            }
	        },
	        step: {
	            type: Number,
	            default: 1
	        }
	    },
	    data: function data() {
	        return {
	            stepTimeout: undefined,
	            stepInterval: undefined,
	            version: 0
	        };
	    },
	
	    computed: {
	        unixRange: function unixRange() {
	            return this.value ? [this.value[0].unix(), this.value[1].unix()] : undefined;
	        },
	        adjustedStep: function adjustedStep() {
	            var maxStep = this.max.unix() - this.min.unix();
	            return Math.min(this.step, maxStep);
	        }
	    },
	    watch: {
	        value: function value() {
	            this.version += 1;
	            if (!(0, _isFinite2.default)(this.version)) this.version = 0;
	        }
	    },
	    methods: {
	        formatUnix: function formatUnix(value) {
	            return _moment2.default.unix(value).format('YYYY-MM-DD HH:mm:ss');
	        },
	        onInput: function onInput(value) {
	            this.$emit('input', [_moment2.default.unix(value[0]), _moment2.default.unix(value[1])]);
	        },
	        onStepMouseDown: function onStepMouseDown(index, sign) {
	            var _this = this;
	
	            if (!this.value) return;
	            var applyStep = function applyStep() {
	                var newValue = [_this.value[0], _this.value[1]];
	                newValue[index] = (0, _moment2.default)(newValue[index]).add(_this.adjustedStep * sign, 'second');
	                if (newValue[0].isAfter(newValue[1])) newValue[0] = (0, _moment2.default)(newValue[1]);
	                if (newValue[1].isBefore(newValue[0])) newValue[1] = (0, _moment2.default)(newValue[0]);
	                _this.$emit('input', newValue);
	            };
	            applyStep();
	            this.stepTimeout = setTimeout(function () {
	                _this.stepInterval = setInterval(applyStep, 150);
	            }, 200);
	        },
	        onStepMouseUp: function onStepMouseUp() {
	            clearTimeout(this.stepTimeout);
	            clearInterval(this.stepInterval);
	        },
	        onInputBlur: function onInputBlur(index, event) {
	            if (!this.value) {
	                event.target.value = '';
	                return;
	            }
	            var val = event.target.value.split(':');
	            val[0] = (val[0] || '').padEnd(2, '0');
	            val[1] = (val[1] || '').padEnd(2, '0');
	            val[2] = (val[2] || '').padEnd(2, '0');
	            var str = val[0] + ':' + val[1] + ':' + val[2];
	
	            var value = (0, _moment2.default)(this.value[index].format('YYYY-MM-DD') + ' ' + str, 'YYYY-MM-DD HH:mm:ss', true);
	            var valid = value.isValid();
	            if (valid) {
	                if (value.isBefore(this.min)) {
	                    value = (0, _moment2.default)(this.max.format('YYYY-MM-DD') + ' ' + str, 'YYYY-MM-DD HH:mm:ss', true);
	                    valid = !value.isAfter(this.max);
	                } else if (value.isAfter(this.max)) {
	                    value = (0, _moment2.default)(this.min.format('YYYY-MM-DD') + ' ' + str, 'YYYY-MM-DD HH:mm:ss', true);
	                    valid = !value.isBefore(this.min);
	                }
	            }
	            var newValue = [this.value[0], this.value[1]];
	            newValue[index] = valid ? value : newValue[index];
	            if (newValue[0].isAfter(newValue[1])) newValue[0] = (0, _moment2.default)(newValue[1]);
	            if (newValue[1].isBefore(newValue[0])) newValue[1] = (0, _moment2.default)(newValue[0]);
	            this.$emit('input', newValue);
	        }
	    }
	};

/***/ }),

/***/ 668:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'customer-add',
	  data: function data() {
	    return {
	      customer: {
	        name: ''
	      },
	      rules: {
	        name: [{ required: true, message: 'Please input customer name', trigger: 'blur' }, { min: 3, message: 'Length should be more then 3', trigger: 'blur' }]
	      }
	    };
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('customers', ['addCustomer']), {
	    resetForm: function resetForm(formName) {
	      this.$refs[formName].resetFields();
	    },
	    submitForm: function submitForm(formName) {
	      var _this = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          _this.addCustomer(_this.customer).then(function (_) {
	            return _this.$router.push({ name: 'customers' });
	          });
	        } else {
	          console.log('error submit!!');
	          return false;
	        }
	      });
	    }
	  })
	};

/***/ }),

/***/ 669:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "customer-edit",
	  props: {
	    id: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      loading: false,
	      customer: {
	        name: "",
	        customerSecretKey: ""
	      },
	      rules: {
	        name: [{
	          required: true,
	          message: "Please input customer name",
	          trigger: "blur"
	        }, { min: 3, message: "Length should be more then 3", trigger: "blur" }]
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)("customers", ["list"])),
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    this.getCustomer(this.id).then(function (resp) {
	      _this.loading = false;
	      _this.customer = resp.data;
	    }).catch(function (_) {
	      _this.loading = false;
	      _this.$router.push({ name: "404" });
	    });
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)("customers", ["saveCustomer", "getCustomer", "addCustomerSecretKey"]), {
	    resetForm: function resetForm(formName) {
	      this.$router.push({ name: "customers" });
	    },
	    generateKey: function generateKey() {
	      var _this2 = this;
	
	      this.loading = true;
	      this.addCustomerSecretKey({ id: this.id }).then(function (resp) {
	        _this2.customer = resp.data;
	        _this2.loading = false;
	      }).catch(function (_) {
	        _this2.loading = false;
	      });
	    },
	    submitForm: function submitForm(formName) {
	      var _this3 = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          _this3.saveCustomer({ id: _this3.id, customer: _this3.customer }).then(function (_) {
	            return _this3.$router.push({ name: "customers" });
	          });
	        } else {
	          console.log("error submit!!");
	          return false;
	        }
	      });
	    }
	  })
	};

/***/ }),

/***/ 670:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'customers',
	  data: function data() {
	    return {
	      loading: false
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('customers', ['list']), {
	    pagination: {
	      get: function get() {
	        return this.$store.getters['customers/pagination'];
	      },
	      set: function set(value) {
	        this.$store.commit('customers/setPagination', value);
	      }
	    }
	  }),
	  watch: {
	    pagination: {
	      handler: function handler() {
	        var _this = this;
	
	        this.loading = true;
	        this.fetchCustomers().then(function (result) {
	          _this.loading = false;
	        });
	      },
	
	      deep: true
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('customers', ['fetchCustomers', 'deleteCustomer']), {
	    handleEdit: function handleEdit(row) {
	      this.$router.push({ name: 'editCustomer', params: { id: row.id } });
	    },
	    handleView: function handleView(row) {
	      this.$router.push({ name: 'viewCustomer', params: { id: row.id } });
	    },
	    handleDelete: function handleDelete(row) {
	      var _this2 = this;
	
	      this.$confirm('This will delete customer. Continue?', 'Warning', {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      }).then(function () {
	        _this2.deleteCustomer({ id: row.id }).then(function (_) {
	          return _this2.fetchCustomers();
	        }).then(function (_) {
	          return _this2.$message({
	            type: 'success',
	            message: 'Delete completed'
	          });
	        });
	      }).catch(function () {
	        _this2.$message({
	          type: 'info',
	          message: 'Delete canceled'
	        });
	      });
	    },
	    handleAdd: function handleAdd() {
	      this.$router.push({ name: 'addCustomer' });
	    },
	    handleSizeChange: function handleSizeChange(pageSize) {
	      this.pagination = (0, _extends3.default)({}, this.pagination, { pageSize: pageSize });
	    },
	    handleCurrentChange: function handleCurrentChange(pageNum) {
	      this.pagination = (0, _extends3.default)({}, this.pagination, { pageNum: pageNum });
	    }
	  }),
	  created: function created() {
	    this.fetchCustomers();
	  }
	};

/***/ }),

/***/ 671:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "customer-view",
	  props: {
	    id: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      loading: false,
	      customer: {
	        id: "",
	        name: "",
	        customerSecretKey: "",
	        created: ""
	      }
	    };
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)("customers", ["getCustomer"])),
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    this.getCustomer(this.id).then(function (resp) {
	      _this.loading = false;
	      _this.customer = resp.data;
	    }).catch(function (_) {
	      _this.loading = false;
	      _this.$router.push({ name: "404" });
	    });
	  }
	};

/***/ }),

/***/ 672:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotFound',
	  data: function data() {
	    return {
	      text: ['Oops! You can\'t access to this page', 'Meanwhile', 'you may return to dashboard']
	    };
	  }
	};

/***/ }),

/***/ 673:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'NotFound',
	  data: function data() {
	    return {
	      text: ['Oops! Page not found', 'We could not find the page you were looking for', 'Meanwhile', 'you may return to dashboard', 'or try using the search form.']
	    };
	  }
	};

/***/ }),

/***/ 674:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardSecond'
	};

/***/ }),

/***/ 675:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'dashboard-first',
	  data: function data() {
	    return {
	      loading: true
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('devices', ['pagination'])),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('devices', ['fetchDevices'])),
	  created: function created() {
	    var _this = this;
	
	    this.loading = true;
	    this.fetchDevices().then(function (_) {
	      return _this.$nextTick(function (_) {
	        return _this.loading = false;
	      });
	    }).catch(function (_) {
	      return _this.$nextTick(function (_) {
	        return _this.loading = false;
	      });
	    });
	  }
	};

/***/ }),

/***/ 676:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "device-add",
	  data: function data() {
	    return {
	      customerName: "",
	      device: {
	        serial: "",
	        name: "",
	        iccId: "",
	        customer: {},
	        customerId: undefined,
	        channels: [{
	          name: "",
	          channelIndex: 0
	        }]
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    isAdmin: "account/isAdmin",
	    customers: "customers/list"
	  }), {
	    rules: function rules() {
	      return (0, _extends3.default)({
	        name: [{
	          required: true,
	          message: "Please input device name",
	          trigger: "blur"
	        }, { min: 3, message: "Length should be more then 3", trigger: "blur" }],
	        serial: [{
	          required: true,
	          message: "Please input device serial",
	          trigger: "blur"
	        }, { min: 4, message: "Length should be more then 4", trigger: "blur" }],
	        iccId: [{
	          required: true,
	          message: "Please input device ICC Id",
	          trigger: "blur"
	        }, { min: 6, message: "Length should be more then 6", trigger: "blur" }]
	      }, this.isAdmin ? {
	        customerId: [{
	          type: "number",
	          required: true,
	          message: "Please select customer",
	          trigger: "blur"
	        }]
	      } : {});
	    }
	  }),
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)({
	    addDevice: "devices/addDevice",
	    fetchCustomers: "customers/fetchCustomers"
	  }), {
	    resetForm: function resetForm(formName) {
	      this.$refs[formName].resetFields();
	    },
	    submitForm: function submitForm(formName) {
	      var _this = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          _this.addDevice(_this.device).then(function (_) {
	            return _this.$router.push({ name: "devices" });
	          });
	        } else {
	          console.log("error submit!!");
	          return false;
	        }
	      });
	    },
	    addChannel: function addChannel() {
	      this.device.channels.push({
	        name: "",
	        channelIndex: 0
	      });
	    },
	    handleRemove: function handleRemove(index) {
	      if (this.device.channels.length > 1) {
	        this.device.channels.splice(index, 1);
	      }
	    }
	  }),
	  created: function created() {
	    this.isAdmin && this.fetchCustomers();
	  }
	};

/***/ }),

/***/ 677:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "device-edit",
	  props: {
	    serial: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      loading: false,
	      device: {
	        serial: "",
	        name: "",
	        iccId: "",
	        channels: [{
	          name: "",
	          channelIndex: 0
	        }]
	      },
	      rules: {
	        name: [{
	          required: true,
	          message: "Please input device name",
	          trigger: "blur"
	        }, { min: 3, message: "Length should be more then 3", trigger: "blur" }],
	        serial: [{
	          required: true,
	          message: "Please input device serial",
	          trigger: "blur"
	        }, { min: 4, message: "Length should be more then 4", trigger: "blur" }],
	        iccId: [{
	          required: true,
	          message: "Please input device ICC Id",
	          trigger: "blur"
	        }, { min: 6, message: "Length should be more then 6", trigger: "blur" }]
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)("devices", ["list"])),
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    this.getDevice(this.serial).then(function (resp) {
	      _this.loading = false;
	      _this.device = resp.data;
	    }).catch(function (_) {
	      _this.loading = false;
	      _this.$router.push({ name: "404" });
	    });
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)("devices", ["saveDevice", "getDevice"]), {
	    resetForm: function resetForm(formName) {
	      this.$refs[formName].resetFields();
	    },
	    submitForm: function submitForm(formName) {
	      var _this2 = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          _this2.loading = true;
	          var _device = _this2.device,
	              serial = _device.serial,
	              name = _device.name,
	              iccId = _device.iccId,
	              channels = _device.channels;
	
	          _this2.saveDevice({
	            serial: _this2.serial,
	            device: { serial: serial, name: name, iccId: iccId, channels: channels }
	          }).then(function (_) {
	            return _this2.$router.push({ name: "devices" });
	          }).catch(function (ex) {
	            _this2.loading = false;
	            _this2.$message({
	              type: "error",
	              message: ex.response.data.error
	            });
	          });
	        } else {
	          console.log("error submit!!");
	          return false;
	        }
	      });
	    },
	    addChannel: function addChannel() {
	      this.device.channels.push({
	        name: "",
	        channelIndex: 0
	      });
	    },
	    handleRemove: function handleRemove(index) {
	      if (this.device.channels.length > 1) {
	        this.device.channels.splice(index, 1);
	      }
	    }
	  })
	};

/***/ }),

/***/ 678:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _isNan = __webpack_require__(699);
	
	var _isNan2 = _interopRequireDefault(_isNan);
	
	var _keys = __webpack_require__(52);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _regenerator = __webpack_require__(274);
	
	var _regenerator2 = _interopRequireDefault(_regenerator);
	
	var _promise = __webpack_require__(81);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _asyncToGenerator2 = __webpack_require__(273);
	
	var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);
	
	var _toConsumableArray2 = __webpack_require__(704);
	
	var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	var _VideoSearchDialog = __webpack_require__(1127);
	
	var _VideoSearchDialog2 = _interopRequireDefault(_VideoSearchDialog);
	
	var _LiveStreamDialog = __webpack_require__(1123);
	
	var _LiveStreamDialog2 = _interopRequireDefault(_LiveStreamDialog);
	
	var _SnapshotDialog = __webpack_require__(1125);
	
	var _SnapshotDialog2 = _interopRequireDefault(_SnapshotDialog);
	
	var _XmlDialog = __webpack_require__(1129);
	
	var _XmlDialog2 = _interopRequireDefault(_XmlDialog);
	
	var _OnlineStatus = __webpack_require__(1110);
	
	var _OnlineStatus2 = _interopRequireDefault(_OnlineStatus);
	
	var _devices = __webpack_require__(182);
	
	var _axios = __webpack_require__(59);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "devices",
	  components: {
	    OnlineStatus: _OnlineStatus2.default,
	    VideoSearchDialog: _VideoSearchDialog2.default,
	    LiveStreamDialog: _LiveStreamDialog2.default,
	    SnapshotDialog: _SnapshotDialog2.default,
	    XmlDialog: _XmlDialog2.default
	  },
	  data: function data() {
	    return {
	      currentDevice: null,
	      currentRow: null,
	      videoSearchVisible: false,
	      liveStreamVisible: false,
	      snapshotVisible: false,
	      loading: false,
	      xmlVisible: false,
	      xmlData: "",
	      isLoading: false,
	      isSuccessful: false,
	      hasError: false,
	      isSearched: false,
	      activityFilter: "ALL",
	      clientMode: true,
	      allDevices: [],
	      filteredDataset: []
	
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)("devices", ["list", "activeDevices", "search"]), {
	    tableData: function tableData() {
	      var sorted = this.sortOnlineFirst(this.filteredDataset);
	      var from = (this.pagination.pageNum - 1) * this.pagination.pageSize;
	      var to = from + this.pagination.pageSize;
	      return sorted.slice(from, to);
	    },
	    tableTotal: function tableTotal() {
	      return this.filteredDataset.length;
	    },
	
	
	    search: {
	      get: function get() {
	        return this.$store.getters["devices/search"];
	      },
	      set: function set(value) {
	        this.$store.commit("devices/setSearch", value);
	      }
	    },
	    pagination: {
	      get: function get() {
	        return this.$store.getters["devices/pagination"];
	      },
	      set: function set(value) {
	        this.$store.commit("devices/setPagination", value);
	      }
	    }
	  }),
	  watch: {
	    pagination: {
	      handler: function handler() {
	        if (this.clientMode) return;
	        this.loadDevices();
	      }
	    },
	    deep: true
	
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapMutations)("devices", ["setActiveDevices"]), (0, _vuex.mapActions)("devices", ["fetchDevices", "fetchActiveDevices", "deleteDevice", "restoreDevice", "searchDevices", "xmlSend"]), {
	    getXml: function getXml(row) {
	      var _this = this;
	
	      this.xmlData = "";
	      this.isLoading = true;
	      this.isSuccessful = false;
	      var token = localStorage.getItem("jwt_access_token");
	      var deviceSerial = { "deviceSerial": "" + row.serial };
	      _axios2.default.post((0, _constants.getUrl)(_constants.URL.GET_XML_FILE), deviceSerial, {
	        headers: {
	          'Authorization': "Bearer " + token,
	          'Content-Type': 'application/json; charset=UTF-8'
	        }
	      }).then(function (res) {
	        _this.isLoading = false;
	        _this.xmlData = res.data.configuration;
	      }).catch(function (err) {
	        return console.log(err);
	      });
	    },
	    tableRowClassName: function tableRowClassName(_ref) {
	      var row = _ref.row;
	
	      return (row.disabled ? "disabled-row" : "") + " " + "device-row";
	    },
	    isDeviceOnline: function isDeviceOnline(serial) {
	      var key = String(serial);
	      return this.activeDevices.some(function (activeSerial) {
	        return String(activeSerial) === key;
	      });
	    },
	    sortOnlineFirst: function sortOnlineFirst(devices) {
	      var _this2 = this;
	
	      var list = Array.isArray(devices) ? [].concat((0, _toConsumableArray3.default)(devices)) : [];
	
	      return list.sort(function (a, b) {
	        var aOnline = _this2.isDeviceOnline(a.serial) ? 1 : 0;
	        var bOnline = _this2.isDeviceOnline(b.serial) ? 1 : 0;
	
	        if (aOnline !== bOnline) {
	          return bOnline - aOnline;
	        }
	
	        var aName = String(a.name || a.serial || '').toLowerCase();
	        var bName = String(b.name || b.serial || '').toLowerCase();
	        return aName.localeCompare(bName);
	      });
	    },
	    rowMatchesQuery: function rowMatchesQuery(row, query) {
	      if (!query) return true;
	
	      var customerName = row.customer && row.customer.name ? row.customer.name : "";
	      var fields = [row.serial, row.name, row.deviceName, row.iccId, row.created, customerName];
	
	      return fields.some(function (value) {
	        return String(value || "").toLowerCase().includes(query);
	      });
	    },
	    fetchAllDevices: function fetchAllDevices() {
	      var _this3 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
	        var pageSize, firstResp, firstDevices, totalCount, totalPages, requests, page, responses, otherDevices;
	        return _regenerator2.default.wrap(function _callee$(_context) {
	          while (1) {
	            switch (_context.prev = _context.next) {
	              case 0:
	                pageSize = 200;
	                _context.next = 3;
	                return _devices.devicesClient.getDevices(1, pageSize);
	
	              case 3:
	                firstResp = _context.sent;
	                firstDevices = firstResp.data && firstResp.data.devices || [];
	                totalCount = firstResp.data && firstResp.data.totalCount || firstDevices.length;
	                totalPages = Math.max(1, Math.ceil(totalCount / pageSize));
	                requests = [];
	
	                for (page = 2; page <= totalPages; page += 1) {
	                  requests.push(_devices.devicesClient.getDevices(page, pageSize));
	                }
	
	                _context.next = 11;
	                return _promise2.default.all(requests);
	
	              case 11:
	                responses = _context.sent;
	                otherDevices = responses.flatMap(function (resp) {
	                  return resp.data && resp.data.devices || [];
	                });
	                return _context.abrupt("return", [].concat((0, _toConsumableArray3.default)(firstDevices), (0, _toConsumableArray3.default)(otherDevices)));
	
	              case 14:
	              case "end":
	                return _context.stop();
	            }
	          }
	        }, _callee, _this3);
	      }))();
	    },
	    refreshActiveDevicesFor: function refreshActiveDevicesFor(serials) {
	      var _this4 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
	        var resp, statusMap, activeDevices;
	        return _regenerator2.default.wrap(function _callee2$(_context2) {
	          while (1) {
	            switch (_context2.prev = _context2.next) {
	              case 0:
	                if (!(!Array.isArray(serials) || serials.length === 0)) {
	                  _context2.next = 3;
	                  break;
	                }
	
	                _this4.setActiveDevices([]);
	                return _context2.abrupt("return");
	
	              case 3:
	                _context2.next = 5;
	                return _devices.devicesClient.getStatuses(serials);
	
	              case 5:
	                resp = _context2.sent;
	                statusMap = resp && resp.data || {};
	                activeDevices = (0, _keys2.default)(statusMap).filter(function (serial) {
	                  return statusMap[serial] === "ONLINE";
	                });
	
	                _this4.setActiveDevices(activeDevices);
	
	              case 9:
	              case "end":
	                return _context2.stop();
	            }
	          }
	        }, _callee2, _this4);
	      }))();
	    },
	    rebuildFilteredDataset: function rebuildFilteredDataset() {
	      var _this5 = this;
	
	      var query = (this.search || "").trim().toLowerCase();
	      var filterActiveOnly = this.activityFilter === "ACTIVE";
	
	      this.filteredDataset = this.allDevices.filter(function (row) {
	        if (filterActiveOnly && !_this5.isDeviceOnline(row.serial)) {
	          return false;
	        }
	
	        return _this5.rowMatchesQuery(row, query);
	      });
	    },
	    applyGlobalFilters: function applyGlobalFilters() {
	      var _this6 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
	        return _regenerator2.default.wrap(function _callee3$(_context3) {
	          while (1) {
	            switch (_context3.prev = _context3.next) {
	              case 0:
	                _this6.loading = true;
	
	                if (_this6.pagination.pageNum !== 1) {
	                  _this6.pagination = (0, _extends3.default)({}, _this6.pagination, { pageNum: 1 });
	                }
	
	                _context3.prev = 2;
	
	                if (_this6.allDevices.length) {
	                  _context3.next = 9;
	                  break;
	                }
	
	                _context3.next = 6;
	                return _this6.fetchAllDevices();
	
	              case 6:
	                _this6.allDevices = _context3.sent;
	                _context3.next = 9;
	                return _this6.refreshActiveDevicesFor(_this6.allDevices.map(function (d) {
	                  return d.serial;
	                }));
	
	              case 9:
	
	                _this6.rebuildFilteredDataset();
	
	              case 10:
	                _context3.prev = 10;
	
	                _this6.loading = false;
	                return _context3.finish(10);
	
	              case 13:
	              case "end":
	                return _context3.stop();
	            }
	          }
	        }, _callee3, _this6, [[2,, 10, 13]]);
	      }))();
	    },
	    loadDevices: function loadDevices() {
	      var _this7 = this;
	
	      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee4() {
	        return _regenerator2.default.wrap(function _callee4$(_context4) {
	          while (1) {
	            switch (_context4.prev = _context4.next) {
	              case 0:
	                _this7.loading = true;
	                _context4.prev = 1;
	                _context4.next = 4;
	                return _this7.fetchAllDevices();
	
	              case 4:
	                _this7.allDevices = _context4.sent;
	                _context4.next = 7;
	                return _this7.refreshActiveDevicesFor(_this7.allDevices.map(function (d) {
	                  return d.serial;
	                }));
	
	              case 7:
	                _this7.rebuildFilteredDataset();
	                _this7.isSearched = false;
	
	              case 9:
	                _context4.prev = 9;
	
	                _this7.loading = false;
	                return _context4.finish(9);
	
	              case 12:
	              case "end":
	                return _context4.stop();
	            }
	          }
	        }, _callee4, _this7, [[1,, 9, 12]]);
	      }))();
	    },
	    formatLastActive: function formatLastActive(row) {
	      if (this.isDeviceOnline(row.serial)) {
	        return "Online";
	      }
	
	      var candidates = [row.lastActiveOn, row.lastActive, row.lastSeen, row.lastOnline, row.lastHeartbeat, row.updated, row.updatedAt, row.modified, row.modifiedAt];
	
	      var value = candidates.find(function (v) {
	        return v !== undefined && v !== null && v !== "";
	      });
	      if (!value) {
	        return "N/A";
	      }
	
	      var date = new Date(value);
	      if ((0, _isNan2.default)(date.getTime())) return String(value);
	
	      var pad = function pad(n) {
	        return String(n).padStart(2, "0");
	      };
	      return date.getFullYear() + "-" + pad(date.getMonth() + 1) + "-" + pad(date.getDate()) + " " + pad(date.getHours()) + ":" + pad(date.getMinutes()) + ":" + pad(date.getSeconds());
	    },
	    handleEdit: function handleEdit(row) {
	      this.$router.push({ name: "editDevice", params: { serial: row.serial } });
	    },
	    onRowClick: function onRowClick(_ref2) {
	      var serial = _ref2.serial;
	
	      this.$router.push({ name: "viewDevice", params: { serial: serial } });
	    },
	    handleDelete: function handleDelete(row) {
	      var _this8 = this;
	
	      this.$confirm("This will delete device. Continue?", "Warning", {
	        confirmButtonText: "OK",
	        cancelButtonText: "Cancel",
	        type: "warning"
	      }).then(function () {
	        _this8.deleteDevice({ serial: row.serial }).then(function (_) {
	          return _this8.$message({
	            type: "success",
	            message: "Delete completed"
	          });
	        });
	      }).catch(function () {
	        _this8.$message({
	          type: "info",
	          message: "Delete canceled"
	        });
	      });
	    },
	    handleRestore: function handleRestore(row) {
	      var _this9 = this;
	
	      this.restoreDevice({ serial: row.serial }).then(function (_) {
	        return _this9.$message({
	          type: "success",
	          message: "Restoring completed"
	        });
	      }).then(function (_) {
	        _this9.loading = true;
	        _this9.fetchDevices().then(function () {
	          return _this9.fetchActiveDevices();
	        }).then(function (_) {
	          return _this9.loading = false;
	        }).catch(function (_) {
	          return _this9.loading = false;
	        });
	      });
	    },
	    handleAdd: function handleAdd() {
	      this.$router.push({ name: "addDevice" });
	    },
	    handleSizeChange: function handleSizeChange(pageSize) {
	      this.pagination = (0, _extends3.default)({}, this.pagination, { pageSize: pageSize });
	    },
	    handleCurrentChange: function handleCurrentChange(pageNum) {
	      this.pagination = (0, _extends3.default)({}, this.pagination, { pageNum: pageNum });
	    },
	    searchData: function searchData() {
	      this.isSearched = true;
	      this.applyGlobalFilters();
	    }
	  }),
	
	  created: function created() {
	
	    this.loadDevices();
	  }
	};

/***/ }),

/***/ 679:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: ['device', 'visible'],
	  data: function data() {
	    return {
	      rules: {
	        channels: [{
	          type: "array",
	          required: true,
	          message: "Please select channels",
	          trigger: "blur"
	        }]
	      },
	      streamRequest: {
	        channels: []
	      }
	    };
	  },
	
	  computed: {
	    channels: function channels() {
	      return (this.device || { channels: [] }).channels;
	    }
	  },
	  watch: {
	    device: function device() {
	      this.streamRequest.channels = [];
	    }
	  },
	  methods: {
	    startStream: function startStream() {
	      var _this = this;
	
	      this.$refs.streamRequest.validate(function (valid) {
	        if (!valid) return;
	        var channels = _this.streamRequest.channels;
	
	        _this.$router.push({
	          name: "streamDevice",
	          params: { serial: _this.device.serial },
	          query: { channels: channels }
	        });
	      });
	    }
	  }
	};

/***/ }),

/***/ 680:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _hls = __webpack_require__(1054);
	
	var _hls2 = _interopRequireDefault(_hls);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  props: {
	    src: String
	  },
	  data: function data() {
	    return {
	      hls: null,
	      hlsSupported: _hls2.default.isSupported(),
	      componentDestroyed: false
	    };
	  },
	
	  watch: {
	    src: function src() {
	      this.init();
	    }
	  },
	  methods: {
	    destroy: function destroy() {
	      if (this.hls) {
	        this.hls.destroy();
	        this.hls = null;
	      }
	    },
	    init: function init() {
	      var _this = this;
	
	      this.destroy();
	      var src = this.src;
	      if (!src) return;
	      this.$nextTick(function () {
	        if (_this.src !== src) return;
	        var video = _this.$refs.video;
	        if (!video) return;
	        if (_this.hlsSupported) {
	          var hls = new _hls2.default({
	            liveSyncDurationCount: 3,
	            liveMaxLatencyDurationCount: 6,
	            liveDurationInfinity: true,
	            liveBackBufferLength: 0
	          });
	          _this.hls = hls;
	          hls.attachMedia(_this.$refs.video);
	          hls.on(_hls2.default.Events.MEDIA_ATTACHED, function () {
	            console.log("video and hls.js are now bound together!");
	            hls.loadSource(src);
	          });
	          hls.on(_hls2.default.Events.ERROR, function (event, data) {
	            if (!data.fatal) return;
	            console.log(data);
	            if (data.type === _hls2.default.ErrorTypes.NETWORK_ERROR) {
	              console.log("fatal network error encountered, try to recover");
	              hls.startLoad();
	              return;
	            }
	            if (data.type === _hls2.default.ErrorTypes.MEDIA_ERROR) {
	              console.log("fatal media error encountered, try to recover");
	              hls.recoverMediaError();
	              return;
	            }
	            console.log("fatal error encountered, destroing the player");
	            this.destroy();
	          });
	          hls.on(_hls2.default.Events.MANIFEST_PARSED, function (event, data) {
	            console.log("manifest loaded, found " + data.levels.length + " quality level");
	            video.muted = true;
	            video.play();
	          });
	        }
	      });
	    }
	  },
	  mounted: function mounted() {
	    this.init();
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.destroy();
	    this.componentDestroyed = true;
	  }
	};

/***/ }),

/***/ 681:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _snapshot = __webpack_require__(655);
	
	exports.default = {
	    props: ['device', 'visible'],
	    data: function data() {
	        return {
	            rules: {
	                channels: [{
	                    type: "array",
	                    required: true,
	                    message: "Please select channels",
	                    trigger: "blur"
	                }]
	            },
	            snapshotRequest: {
	                channels: []
	            },
	            loading: false
	        };
	    },
	
	    computed: {
	        channels: function channels() {
	            return (this.device || { channels: [] }).channels;
	        }
	    },
	    watch: {
	        device: function device() {
	            this.snapshotRequest.channels = [];
	            this.loading = false;
	        }
	    },
	    methods: {
	        makeSnapshot: function makeSnapshot() {
	            var _this = this;
	
	            this.loading = true;
	            this.$refs.snapshotRequest.validate(function (valid) {
	                if (!valid) {
	                    _this.loading = false;
	                    return;
	                }
	                var channels = _this.snapshotRequest.channels;
	
	                var serial = _this.device.serial;
	                _snapshot.snapshotClient.makeSnapshot(serial, channels).then(function (_ref) {
	                    var status = _ref.data.status;
	
	                    if (serial !== _this.device.serial) return;
	                    _this.loading = false;
	                    if (status === 'FAIL') {
	                        _this.$notify.error({
	                            title: 'Error',
	                            message: 'Unable to make snapshots for requested channels'
	                        });
	                    } else {
	                        _this.$notify.success({
	                            title: 'Success',
	                            message: 'Snapshot request completed. Click on this message to watch the downloading proggress',
	                            customClass: 'download-success-notification',
	                            onClick: function onClick() {
	                                return _this.$router.push({ name: "viewDevice", params: { serial: serial } });
	                            }
	                        });
	                    }
	                }).catch(function (error) {
	                    if (serial !== _this.device.serial) return;
	                    _this.loading = false;
	                    if (error.response) {
	                        var status = error.response.status;
	                        if (status === 503) {
	                            _this.$notify.error({
	                                title: 'Error',
	                                message: 'Unable to make snapshots because the device unavailable'
	                            });
	                            return;
	                        }
	                    }
	                    _this.$notify.error({
	                        title: 'Error',
	                        message: 'Unable to make snapshots for requested channels'
	                    });
	                });
	            });
	        }
	    }
	};

/***/ }),

/***/ 682:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _keys = __webpack_require__(52);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _isInteger = __webpack_require__(698);
	
	var _isInteger2 = _interopRequireDefault(_isInteger);
	
	var _Player = __webpack_require__(1124);
	
	var _Player2 = _interopRequireDefault(_Player);
	
	var _video = __webpack_require__(272);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  components: {
	    Player: _Player2.default
	  },
	  props: {
	    serial: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      loading: false,
	      componentDestroyed: false,
	      streamUrls: {},
	      keepAliveTimer: null,
	      bootstrapTimer: null
	    };
	  },
	
	  computed: {
	    channels: function channels() {
	      var channels = this.$route.query.channels;
	
	      return (Array.isArray(channels) ? channels : [channels]).map(function (x) {
	        return parseInt(x);
	      }).filter(function (x) {
	        return (0, _isInteger2.default)(x);
	      }).sort();
	    },
	    videos: function videos() {
	      var _this = this;
	
	      return this.channels.map(function (ch) {
	        return _this.streamUrls[ch];
	      }).filter(function (x) {
	        return !!x;
	      });
	    },
	    grid: function grid() {
	      var count = this.videos.length;
	      var result = [];
	
	      for (var i = 0; i < count; i++) {
	        var video = this.videos[i];
	        if (i % 2 === 0) {
	          result.push([video]);
	        } else {
	          result[result.length - 1].push(video);
	        }
	      }
	      return result;
	    }
	  },
	  watch: {
	    channels: {
	      immediate: true,
	      handler: function handler(val) {
	        var _this2 = this;
	
	        val.forEach(function (ch) {
	          if (_this2.streamUrls[ch] === undefined) {
	            _this2.$set(_this2.streamUrls, ch, null);
	          }
	        });
	      }
	    }
	  },
	  methods: {
	    requestLiveStream: function requestLiveStream() {
	      var _this3 = this;
	
	      if (!this.channels.length) return;
	      if (this.loading) return;
	      this.loading = true;
	      _video.videoClient.requestLiveStream(this.serial, this.channels).then(function (_ref) {
	        var _ref$data = _ref.data,
	            status = _ref$data.status,
	            hlsStreamUrls = _ref$data.hlsStreamUrls;
	
	        _this3.loading = false;
	        if (status === 'FAIL') {
	          _this3.$notify.error({
	            title: 'Error',
	            message: 'Unable to request the live stream for all of requested channels'
	          });
	        } else if (status === 'PARTIAL_SUCCESS') {
	          _this3.$notify.warning({
	            title: 'Warning',
	            message: 'Unable to request the live stream for some of requested channels'
	          });
	        }
	        (0, _keys2.default)(hlsStreamUrls).forEach(function (ch) {
	          _this3.streamUrls[ch] = hlsStreamUrls[ch];
	        });
	      }).catch(function (error) {
	        _this3.loading = false;
	        if (error.response) {
	          var status = error.response.status;
	          if (status === 503) {
	            _this3.$notify.error({
	              title: 'Error',
	              message: 'Unable to request the live stream because the device unavailable'
	            });
	          }
	        }
	      });
	    }
	  },
	  mounted: function mounted() {
	    var _this4 = this;
	
	    this.requestLiveStream();
	
	    this.keepAliveTimer = setInterval(function () {
	      if (_this4.componentDestroyed) return;
	      _this4.requestLiveStream();
	    }, 15000);
	
	    this.bootstrapTimer = setInterval(function () {
	      if (_this4.componentDestroyed) return;
	      if (_this4.videos.length > 0) {
	        clearInterval(_this4.bootstrapTimer);
	        _this4.bootstrapTimer = null;
	        return;
	      }
	      _this4.requestLiveStream();
	    }, 3000);
	  },
	  beforeDestroy: function beforeDestroy() {
	    this.keepAliveTimer && clearInterval(this.keepAliveTimer);
	    this.bootstrapTimer && clearInterval(this.bootstrapTimer);
	    this.componentDestroyed = true;
	  }
	};

/***/ }),

/***/ 683:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _keys = __webpack_require__(52);
	
	var _keys2 = _interopRequireDefault(_keys);
	
	var _video = __webpack_require__(272);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _TimeRangeSlider = __webpack_require__(1111);
	
	var _TimeRangeSlider2 = _interopRequireDefault(_TimeRangeSlider);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    components: {
	        TimeRangeSlider: _TimeRangeSlider2.default
	    },
	    props: ['device', 'visible'],
	    data: function data() {
	        return {
	            dateRange: null,
	            loading: false,
	            downloading: false,
	            searchResult: [],
	            selected: {}
	        };
	    },
	
	    computed: {
	        tableData: function tableData() {
	            var _this = this;
	
	            return this.searchResult.map(function (_ref) {
	                var id = _ref.id,
	                    channel = _ref.channel,
	                    startTime = _ref.startTime,
	                    endTime = _ref.endTime;
	                return {
	                    id: id,
	                    channel: channel,
	                    channelName: (_this.device.channels[channel] || { name: 'Index ' + channel }).name,
	                    startTime: (0, _moment2.default)(startTime),
	                    endTime: (0, _moment2.default)(endTime)
	                };
	            });
	        },
	        downloadDisabled: function downloadDisabled() {
	            var _this2 = this;
	
	            var loading = this.loading;
	            var downloading = this.downloading;
	            var selectedLength = (0, _keys2.default)(this.selected).length;
	            if (loading || downloading || !selectedLength) return true;
	            var timeRanges = (0, _keys2.default)(this.selected).map(function (id) {
	                return _this2.selected[id].timeRange;
	            }).filter(function (x) {
	                return !!x;
	            });
	            return timeRanges.length !== selectedLength || timeRanges.some(function (x) {
	                return x[0].isSameOrAfter(x[1]);
	            });
	        },
	        selectedIds: function selectedIds() {
	            return (0, _keys2.default)(this.selected);
	        },
	        channelFilters: function channelFilters() {
	            return (this.device || { channels: [] }).channels.map(function (_ref2) {
	                var name = _ref2.name,
	                    channelIndex = _ref2.channelIndex;
	                return {
	                    text: name,
	                    value: channelIndex
	                };
	            });
	        }
	    },
	    watch: {
	        device: function device() {
	            this.loading = false;
	            this.dateRange = null;
	            this.search();
	        },
	        dateRange: function dateRange() {
	            this.search();
	        }
	    },
	    methods: {
	        search: function search() {
	            var _this3 = this;
	
	            if (!this.dateRange) {
	                this.searchResult = [];
	                return;
	            }
	            this.loading = true;
	            var serial = this.device.serial;
	            var from = (0, _moment2.default)(this.dateRange[0]);
	            var to = (0, _moment2.default)(this.dateRange[1]);
	            _video.videoClient.search(serial, from, to).then(function (_ref3) {
	                var files = _ref3.data.files;
	
	                if (serial !== _this3.device.serial) return;
	                _this3.loading = false;
	                _this3.searchResult = files;
	            }).catch(function () {
	                if (serial !== _this3.device.serial) return;
	                _this3.loading = false;
	                _this3.searchResult = [];
	                _this3.$notify.error({
	                    title: 'Error',
	                    message: 'Unable to load historical lookup result'
	                });
	            });
	        },
	        download: function download() {
	            var _this4 = this;
	
	            var serial = this.device.serial;
	            var files = (0, _keys2.default)(this.selected).map(function (id) {
	                return {
	                    id: id,
	                    from: _this4.selected[id].timeRange[0],
	                    to: _this4.selected[id].timeRange[1]
	                };
	            });
	            this.downloading = true;
	            _video.videoClient.download(serial, files).then(function (_ref4) {
	                var status = _ref4.data.status;
	
	                if (serial !== _this4.device.serial) return;
	                _this4.downloading = false;
	                if (status === 'FAIL') {
	                    _this4.$notify.error({
	                        title: 'Error',
	                        message: 'Unable to download requested files'
	                    });
	                } else {
	                    _this4.$notify.success({
	                        title: 'Success',
	                        message: 'The files download request completed. Click on this message to watch the downloading proggress',
	                        customClass: 'download-success-notification',
	                        onClick: function onClick() {
	                            return _this4.$router.push({ name: "viewDevice", params: { serial: serial } });
	                        }
	                    });
	                }
	            }).catch(function (error) {
	                if (serial !== _this4.device.serial) return;
	                _this4.downloading = false;
	                if (error.response) {
	                    var status = error.response.status;
	                    if (status === 503) {
	                        _this4.$notify.error({
	                            title: 'Error',
	                            message: 'Unable to download requested files because the device unavailable'
	                        });
	                        return;
	                    }
	                }
	                _this4.$notify.error({
	                    title: 'Error',
	                    message: 'Unable to download requested files'
	                });
	            });
	        },
	        onSelectionChange: function onSelectionChange(rows) {
	            var _this5 = this;
	
	            var selectedIds = rows.reduce(function (obj, row) {
	                obj[row.id] = row;
	                return obj;
	            }, {});
	            (0, _keys2.default)(this.selected).forEach(function (id) {
	                if (!selectedIds[id]) {
	                    _this5.$delete(_this5.selected, id);
	                }
	            });
	            (0, _keys2.default)(selectedIds).forEach(function (id) {
	                if (!_this5.selected[id]) {
	                    var _selectedIds$id = selectedIds[id],
	                        startTime = _selectedIds$id.startTime,
	                        endTime = _selectedIds$id.endTime;
	
	                    _this5.$set(_this5.selected, id, {
	                        timeRange: null
	                    });
	                }
	            });
	        },
	        filterByChannel: function filterByChannel(value, _ref5) {
	            var channel = _ref5.channel;
	
	            return channel === value;
	        }
	    }
	};

/***/ }),

/***/ 684:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _objectWithoutProperties2 = __webpack_require__(703);
	
	var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _moment = __webpack_require__(2);
	
	var _moment2 = _interopRequireDefault(_moment);
	
	var _vuex = __webpack_require__(30);
	
	var _devices = __webpack_require__(182);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: "device-view",
	  props: {
	    serial: {
	      required: true
	    }
	  },
	  filters: {
	    sec: function sec(nano) {
	      return (nano * Math.pow(10, -9)).toFixed(2);
	    }
	  },
	  data: function data() {
	    return {
	      deviceLoading: false,
	      contentLoading: false,
	      timer: undefined,
	      content: [],
	      device: {
	        serial: "",
	        name: "",
	        iccId: "",
	        channels: []
	      },
	      pagination: {
	        pageNum: 1,
	        pageSize: 10,
	        totalCount: 0,
	        rowsPerPageItems: [2, 10, 20, 30, 40, 50, 100]
	      }
	    };
	  },
	
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)("devices", ["list"]), {
	    channelNames: function channelNames() {
	      return this.device.channels.reduce(function (res, ch) {
	        res[ch.channelIndex] = ch.name;
	        return res;
	      }, {});
	    }
	  }),
	
	  mounted: function mounted() {
	    var _this = this;
	
	    this.deviceLoading = true;
	    _devices.devicesClient.getDevice(this.serial).then(function (deviceResponce) {
	      _this.device = (0, _extends3.default)({}, deviceResponce.data);
	      _this.deviceLoading = false;
	      _this.handleContentRefresh();
	    }).catch(function (_) {
	      _this.deviceLoading = false;
	      _this.$router.push({ name: "404" });
	    });
	  },
	  beforeDestroy: function beforeDestroy() {
	    clearTimeout(this.timer);
	  },
	
	
	  methods: {
	    handleSizeChange: function handleSizeChange(pageSize) {
	      this.pagination = (0, _extends3.default)({}, this.pagination, { pageSize: pageSize });
	      this.handleContentRefresh(true);
	    },
	    handleCurrentChange: function handleCurrentChange(pageNum) {
	      this.pagination = (0, _extends3.default)({}, this.pagination, { pageNum: pageNum });
	      this.handleContentRefresh(true);
	    },
	    handleContentRefresh: function handleContentRefresh() {
	      var _this2 = this;
	
	      var clear = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
	
	      clearTimeout(this.timer);
	      this.contentLoading = true;
	      if (clear) this.content = [];
	      var _pagination = this.pagination,
	          pageNum = _pagination.pageNum,
	          pageSize = _pagination.pageSize;
	
	      _devices.devicesClient.getContent(this.device.serial, pageNum, pageSize).then(function (contentResponce) {
	        var _contentResponce$data = contentResponce.data,
	            totalCount = _contentResponce$data.totalCount,
	            pageNum = _contentResponce$data.pageNum,
	            pageSize = _contentResponce$data.pageSize,
	            content = _contentResponce$data.content;
	
	        _this2.pagination = (0, _extends3.default)({}, _this2.pagination, {
	          totalCount: totalCount,
	          pageNum: pageNum,
	          pageSize: pageSize
	        });
	        _this2.content = contentResponce.data.contents.map(function (_ref) {
	          var created = _ref.created,
	              startDateTime = _ref.startDateTime,
	              type = _ref.type,
	              durationNanos = _ref.durationNanos,
	              other = (0, _objectWithoutProperties3.default)(_ref, ["created", "startDateTime", "type", "durationNanos"]);
	          return (0, _extends3.default)({}, other, {
	            created: (0, _moment2.default)(created),
	            startDateTime: (0, _moment2.default)(startDateTime),
	            type: type.startsWith('VIDEO') ? 'VIDEO' : 'SNAPSHOT',
	            duration: _moment2.default.unix(durationNanos / 1000000000, 'seconds').utc()
	          });
	        });
	        if (_this2.content.find(function (x) {
	          return x.status === 'PENDING';
	        })) {
	          _this2.timer = setTimeout(_this2.handleContentRefresh, 30 * 1000);
	        }
	        _this2.contentLoading = false;
	      }).catch(function (_) {
	        _this2.contentLoading = false;
	      });
	    },
	    handleContentDownload: function handleContentDownload(media) {
	      window.open(media.artifactUrl, "_blank");
	    }
	  }
	};

/***/ }),

/***/ 685:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _axios = __webpack_require__(59);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _constants = __webpack_require__(51);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	    props: ['visible', 'device', 'serial', 'xmlData', 'isLoading', 'isSuccessful', 'hasError'],
	    data: function data() {
	        return {
	            loading: false
	        };
	    },
	
	
	    methods: {
	        sendXml: function sendXml() {
	            var _this = this;
	
	            this.hasError = false;
	            this.isLoading = true;
	            var token = localStorage.getItem("jwt_access_token");
	            var data = {
	                "configuration": "" + this.xmlData,
	                "deviceSerial": this.serial
	            };
	            _axios2.default.post((0, _constants.getUrl)(_constants.URL.POST_XML_FILE), data, {
	                headers: {
	                    'Authorization': "Basic " + token,
	                    'Content-Type': 'application/json; charset=UTF-8'
	                }
	            }).then(function (res) {
	                if (res.data.success === true) {
	                    _this.isLoading = false;
	                    _this.isSuccessful = true;
	                    setTimeout(function () {
	                        window.location.reload();
	                    }, 2000);
	                }
	            }).catch(function (err) {
	                _this.isLoading = false;
	                _this.hasError = true;
	            });
	        }
	    }
	};

/***/ }),

/***/ 686:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(81);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'user-add',
	  data: function data() {
	    return {
	      loading: false,
	      user: {
	        name: '',
	        email: '',
	        role: '',
	        customerId: undefined,
	        password: ''
	      },
	      rules: {
	        name: [{ required: true, message: 'Please input user name', trigger: 'blur' }, { min: 3, message: 'Length should be more then 3', trigger: 'blur' }],
	        email: [{
	          type: 'email',
	          message: 'Please input user email',
	          required: true,
	          trigger: 'blur'
	        }],
	        role: [{
	          type: 'string',
	          message: 'Please select user role',
	          required: true,
	          trigger: 'blur'
	        }],
	        customerId: [{
	          type: 'number',
	          message: 'Please select user customer',
	          required: true,
	          trigger: 'blur'
	        }],
	        password: [{
	          type: 'string',
	          message: 'Please input user password',
	          required: true,
	          trigger: 'blur'
	        }]
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    roles: 'users/roles',
	    customers: 'customers/list'
	  })),
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    _promise2.default.all([this.fetchRoles(), this.fetchCustomers()]).then(function (_) {
	      _this.loading = false;
	    }).catch(function (_) {
	      _this.loading = false;
	    });
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('users', ['addUser', 'fetchRoles']), (0, _vuex.mapActions)('customers', ['fetchCustomers']), {
	    resetForm: function resetForm(formName) {
	      this.$refs[formName].resetFields();
	    },
	    submitForm: function submitForm(formName) {
	      var _this2 = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          var _user = _this2.user,
	              name = _user.name,
	              role = _user.role,
	              email = _user.email,
	              customerId = _user.customerId,
	              password = _user.password;
	
	          _this2.loading = true;
	          _this2.addUser({ name: name, role: role, email: email, customerId: customerId, password: password }).then(function (_) {
	            return _this2.$router.push({ name: 'users' });
	          });
	        } else {
	          console.log('error submit!!');
	          return false;
	        }
	      });
	    }
	  })
	};

/***/ }),

/***/ 687:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(81);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'user-edit',
	  props: {
	    id: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      loading: false,
	      user: {
	        name: '',
	        email: '',
	        role: '',
	        customerId: undefined,
	        password: ''
	      },
	      rules: {
	        name: [{ required: true, message: 'Please input user name', trigger: 'blur' }, { min: 3, message: 'Length should be more then 3', trigger: 'blur' }],
	        email: [{
	          type: 'email',
	          message: 'Please input user email',
	          required: true,
	          trigger: 'blur'
	        }],
	        role: [{
	          type: 'string',
	          message: 'Please select user role',
	          required: true,
	          trigger: 'blur'
	        }],
	        customerId: [{
	          type: 'number',
	          message: 'Please select user customer',
	          required: true,
	          trigger: 'blur'
	        }]
	      }
	    };
	  },
	
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)({
	    roles: 'users/roles',
	    customers: 'customers/list'
	  })),
	  mounted: function mounted() {
	    var _this = this;
	
	    this.loading = true;
	    _promise2.default.all([this.getUser(this.id), this.fetchRoles(), this.fetchCustomers()]).then(function (resp) {
	      _this.loading = false;
	      _this.user = resp[0].data;
	    }).catch(function (_) {
	      _this.loading = false;
	      _this.$router.push({ name: '404' });
	    });
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('users', ['saveUser', 'getUser', 'fetchRoles']), (0, _vuex.mapActions)('customers', ['fetchCustomers']), {
	    resetForm: function resetForm(formName) {
	      this.$refs[formName].resetFields();
	    },
	    submitForm: function submitForm(formName) {
	      var _this2 = this;
	
	      this.$refs[formName].validate(function (valid) {
	        if (valid) {
	          var _user = _this2.user,
	              name = _user.name,
	              role = _user.role,
	              email = _user.email,
	              customerId = _user.customerId,
	              password = _user.password;
	
	          _this2.loading = true;
	          _this2.saveUser({ id: _this2.id, user: { name: name, role: role, email: email, customerId: customerId, password: password } }).then(function (_) {
	            return _this2.$router.push({ name: 'users' });
	          });
	        } else {
	          console.log('error submit!!');
	          return false;
	        }
	      });
	    }
	  })
	};

/***/ }),

/***/ 688:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'users',
	  data: function data() {
	    return {
	      loading: false
	    };
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('users', ['list']), {
	    pagination: {
	      get: function get() {
	        return this.$store.getters['users/pagination'];
	      },
	      set: function set(value) {
	        this.$store.commit('users/setPagination', value);
	      }
	    }
	  }),
	  watch: {
	    pagination: {
	      handler: function handler() {
	        var _this = this;
	
	        this.loading = true;
	        this.fetchUsers().then(function (_) {
	          _this.loading = false;
	        });
	      },
	
	      deep: true
	    }
	  },
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('users', ['fetchUsers', 'deleteUser']), {
	    handleEdit: function handleEdit(row) {
	      this.$router.push({ name: 'editUser', params: { id: row.id } });
	    },
	    handleView: function handleView(row) {
	      this.$router.push({ name: 'viewUser', params: { id: row.id } });
	    },
	    handleDelete: function handleDelete(row) {
	      var _this2 = this;
	
	      this.$confirm('This will delete customer. Continue?', 'Warning', {
	        confirmButtonText: 'OK',
	        cancelButtonText: 'Cancel',
	        type: 'warning'
	      }).then(function () {
	        _this2.deleteUser({ id: row.id }).then(function (_) {
	          return _this2.fetchUsers();
	        }).then(function (_) {
	          return _this2.$message({
	            type: 'success',
	            message: 'Delete completed'
	          });
	        });
	      }).catch(function () {
	        _this2.$message({
	          type: 'info',
	          message: 'Delete canceled'
	        });
	      });
	    },
	    handleAdd: function handleAdd() {
	      this.$router.push({ name: 'addUser' });
	    },
	    handleSizeChange: function handleSizeChange(pageSize) {
	      this.pagination = (0, _extends3.default)({}, this.pagination, { pageSize: pageSize });
	    },
	    handleCurrentChange: function handleCurrentChange(pageNum) {
	      this.pagination = (0, _extends3.default)({}, this.pagination, { pageNum: pageNum });
	    }
	  }),
	  created: function created() {
	    this.fetchUsers();
	  }
	};

/***/ }),

/***/ 689:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _promise = __webpack_require__(81);
	
	var _promise2 = _interopRequireDefault(_promise);
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'user-view',
	  props: {
	    id: {
	      required: true
	    }
	  },
	  data: function data() {
	    return {
	      loading: false,
	      user: {
	        name: '',
	        email: '',
	        role: '',
	        customerId: undefined,
	        password: ''
	      }
	    };
	  },
	
	  methods: (0, _extends3.default)({}, (0, _vuex.mapActions)('users', ['getUser', 'fetchRoles']), (0, _vuex.mapActions)('customers', ['fetchCustomers'])),
	  computed: (0, _extends3.default)({
	    customer: function customer() {
	      var _this = this;
	
	      if (this.customers && this.user.customerId) {
	        return this.customers.find(function (x) {
	          return x.id === _this.user.customerId;
	        }) || { name: 'disabled' };
	      }
	      return 'loading...';
	    }
	  }, (0, _vuex.mapGetters)({
	    roles: 'users/roles',
	    customers: 'customers/list'
	  })),
	  mounted: function mounted() {
	    var _this2 = this;
	
	    this.loading = true;
	    _promise2.default.all([this.getUser(this.id), this.fetchRoles(), this.fetchCustomers()]).then(function (resp) {
	      _this2.loading = false;
	      _this2.user = resp[0].data;
	    }).catch(function (_) {
	      _this2.loading = false;
	      _this2.$router.push({ name: '404' });
	    });
	  }
	};

/***/ }),

/***/ 690:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'ControlSidebar',
	  mounted: function mounted() {
	    $(document).ready(function ($) {
	      $('.navbar-stacked').slimScroll({
	        position: 'right',
	        size: '3px',
	        height: '95vh'
	      });
	    });
	  }
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ }),

/***/ 691:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    loading: { type: Boolean, required: false, default: true }
	  }
	};

/***/ }),

/***/ 692:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardFooter',
	  computed: {
	    year: function year() {
	      return new Date().getFullYear();
	    }
	  }
	};

/***/ }),

/***/ 693:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  name: 'DashboardHeader',
	  mounted: function mounted() {}
	};

/***/ }),

/***/ 694:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	  props: {
	    value: { required: false, default: '' },
	    autocomplete: { required: false, default: '', type: String }
	  },
	  data: function data() {
	    return {
	      showPassword: false
	    };
	  }
	};

/***/ }),

/***/ 695:
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function($) {'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends2 = __webpack_require__(31);
	
	var _extends3 = _interopRequireDefault(_extends2);
	
	var _vuex = __webpack_require__(30);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = {
	  name: 'DashboardSidebar',
	  mounted: function mounted() {
	    $(document).ready(function ($) {
	      $('.main-sidebar > div').slimScroll({
	        width: '230px',
	        position: 'left',
	        size: '5px',
	        height: '95vh'
	      });
	    });
	  },
	  computed: (0, _extends3.default)({}, (0, _vuex.mapGetters)('account', ['user', 'isAdmin']))
	};
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(23)))

/***/ }),

/***/ 1038:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1039:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1040:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1041:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1042:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1043:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1044:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1045:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1046:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1047:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1048:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1049:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1050:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1051:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1052:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1053:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 1057:
/***/ (function(module, exports, __webpack_require__) {

	var map = {
		"./af": 370,
		"./af.js": 370,
		"./ar": 377,
		"./ar-dz": 371,
		"./ar-dz.js": 371,
		"./ar-kw": 372,
		"./ar-kw.js": 372,
		"./ar-ly": 373,
		"./ar-ly.js": 373,
		"./ar-ma": 374,
		"./ar-ma.js": 374,
		"./ar-sa": 375,
		"./ar-sa.js": 375,
		"./ar-tn": 376,
		"./ar-tn.js": 376,
		"./ar.js": 377,
		"./az": 378,
		"./az.js": 378,
		"./be": 379,
		"./be.js": 379,
		"./bg": 380,
		"./bg.js": 380,
		"./bm": 381,
		"./bm.js": 381,
		"./bn": 382,
		"./bn.js": 382,
		"./bo": 383,
		"./bo.js": 383,
		"./br": 384,
		"./br.js": 384,
		"./bs": 385,
		"./bs.js": 385,
		"./ca": 386,
		"./ca.js": 386,
		"./cs": 387,
		"./cs.js": 387,
		"./cv": 388,
		"./cv.js": 388,
		"./cy": 389,
		"./cy.js": 389,
		"./da": 390,
		"./da.js": 390,
		"./de": 393,
		"./de-at": 391,
		"./de-at.js": 391,
		"./de-ch": 392,
		"./de-ch.js": 392,
		"./de.js": 393,
		"./dv": 394,
		"./dv.js": 394,
		"./el": 395,
		"./el.js": 395,
		"./en-SG": 396,
		"./en-SG.js": 396,
		"./en-au": 397,
		"./en-au.js": 397,
		"./en-ca": 398,
		"./en-ca.js": 398,
		"./en-gb": 399,
		"./en-gb.js": 399,
		"./en-ie": 400,
		"./en-ie.js": 400,
		"./en-il": 401,
		"./en-il.js": 401,
		"./en-nz": 402,
		"./en-nz.js": 402,
		"./eo": 403,
		"./eo.js": 403,
		"./es": 406,
		"./es-do": 404,
		"./es-do.js": 404,
		"./es-us": 405,
		"./es-us.js": 405,
		"./es.js": 406,
		"./et": 407,
		"./et.js": 407,
		"./eu": 408,
		"./eu.js": 408,
		"./fa": 409,
		"./fa.js": 409,
		"./fi": 410,
		"./fi.js": 410,
		"./fo": 411,
		"./fo.js": 411,
		"./fr": 414,
		"./fr-ca": 412,
		"./fr-ca.js": 412,
		"./fr-ch": 413,
		"./fr-ch.js": 413,
		"./fr.js": 414,
		"./fy": 415,
		"./fy.js": 415,
		"./ga": 416,
		"./ga.js": 416,
		"./gd": 417,
		"./gd.js": 417,
		"./gl": 418,
		"./gl.js": 418,
		"./gom-latn": 419,
		"./gom-latn.js": 419,
		"./gu": 420,
		"./gu.js": 420,
		"./he": 421,
		"./he.js": 421,
		"./hi": 422,
		"./hi.js": 422,
		"./hr": 423,
		"./hr.js": 423,
		"./hu": 424,
		"./hu.js": 424,
		"./hy-am": 425,
		"./hy-am.js": 425,
		"./id": 426,
		"./id.js": 426,
		"./is": 427,
		"./is.js": 427,
		"./it": 429,
		"./it-ch": 428,
		"./it-ch.js": 428,
		"./it.js": 429,
		"./ja": 430,
		"./ja.js": 430,
		"./jv": 431,
		"./jv.js": 431,
		"./ka": 432,
		"./ka.js": 432,
		"./kk": 433,
		"./kk.js": 433,
		"./km": 434,
		"./km.js": 434,
		"./kn": 435,
		"./kn.js": 435,
		"./ko": 436,
		"./ko.js": 436,
		"./ku": 437,
		"./ku.js": 437,
		"./ky": 438,
		"./ky.js": 438,
		"./lb": 439,
		"./lb.js": 439,
		"./lo": 440,
		"./lo.js": 440,
		"./lt": 441,
		"./lt.js": 441,
		"./lv": 442,
		"./lv.js": 442,
		"./me": 443,
		"./me.js": 443,
		"./mi": 444,
		"./mi.js": 444,
		"./mk": 445,
		"./mk.js": 445,
		"./ml": 446,
		"./ml.js": 446,
		"./mn": 447,
		"./mn.js": 447,
		"./mr": 448,
		"./mr.js": 448,
		"./ms": 450,
		"./ms-my": 449,
		"./ms-my.js": 449,
		"./ms.js": 450,
		"./mt": 451,
		"./mt.js": 451,
		"./my": 452,
		"./my.js": 452,
		"./nb": 453,
		"./nb.js": 453,
		"./ne": 454,
		"./ne.js": 454,
		"./nl": 456,
		"./nl-be": 455,
		"./nl-be.js": 455,
		"./nl.js": 456,
		"./nn": 457,
		"./nn.js": 457,
		"./pa-in": 458,
		"./pa-in.js": 458,
		"./pl": 459,
		"./pl.js": 459,
		"./pt": 461,
		"./pt-br": 460,
		"./pt-br.js": 460,
		"./pt.js": 461,
		"./ro": 462,
		"./ro.js": 462,
		"./ru": 463,
		"./ru.js": 463,
		"./sd": 464,
		"./sd.js": 464,
		"./se": 465,
		"./se.js": 465,
		"./si": 466,
		"./si.js": 466,
		"./sk": 467,
		"./sk.js": 467,
		"./sl": 468,
		"./sl.js": 468,
		"./sq": 469,
		"./sq.js": 469,
		"./sr": 471,
		"./sr-cyrl": 470,
		"./sr-cyrl.js": 470,
		"./sr.js": 471,
		"./ss": 472,
		"./ss.js": 472,
		"./sv": 473,
		"./sv.js": 473,
		"./sw": 474,
		"./sw.js": 474,
		"./ta": 475,
		"./ta.js": 475,
		"./te": 476,
		"./te.js": 476,
		"./tet": 477,
		"./tet.js": 477,
		"./tg": 478,
		"./tg.js": 478,
		"./th": 479,
		"./th.js": 479,
		"./tl-ph": 480,
		"./tl-ph.js": 480,
		"./tlh": 481,
		"./tlh.js": 481,
		"./tr": 482,
		"./tr.js": 482,
		"./tzl": 483,
		"./tzl.js": 483,
		"./tzm": 485,
		"./tzm-latn": 484,
		"./tzm-latn.js": 484,
		"./tzm.js": 485,
		"./ug-cn": 486,
		"./ug-cn.js": 486,
		"./uk": 487,
		"./uk.js": 487,
		"./ur": 488,
		"./ur.js": 488,
		"./uz": 490,
		"./uz-latn": 489,
		"./uz-latn.js": 489,
		"./uz.js": 490,
		"./vi": 491,
		"./vi.js": 491,
		"./x-pseudo": 492,
		"./x-pseudo.js": 492,
		"./yo": 493,
		"./yo.js": 493,
		"./zh-cn": 494,
		"./zh-cn.js": 494,
		"./zh-hk": 495,
		"./zh-hk.js": 495,
		"./zh-tw": 496,
		"./zh-tw.js": 496
	};
	function webpackContext(req) {
		return __webpack_require__(webpackContextResolve(req));
	};
	function webpackContextResolve(req) {
		return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
	};
	webpackContext.keys = function webpackContextKeys() {
		return Object.keys(map);
	};
	webpackContext.resolve = webpackContextResolve;
	module.exports = webpackContext;
	webpackContext.id = 1057;


/***/ }),

/***/ 1099:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/img/error.d1a260d.png";

/***/ }),

/***/ 1107:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1052)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(663),
	  /* template */
	  __webpack_require__(1168),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1108:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(664),
	  /* template */
	  __webpack_require__(1171),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1109:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(665),
	  /* template */
	  __webpack_require__(1164),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1110:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1043)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(666),
	  /* template */
	  __webpack_require__(1145),
	  /* scopeId */
	  "data-v-24c2a837",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1111:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1047)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(667),
	  /* template */
	  __webpack_require__(1153),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1112:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(668),
	  /* template */
	  __webpack_require__(1160),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1113:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(669),
	  /* template */
	  __webpack_require__(1149),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1114:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(670),
	  /* template */
	  __webpack_require__(1157),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1115:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(671),
	  /* template */
	  __webpack_require__(1161),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1116:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1050)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(672),
	  /* template */
	  __webpack_require__(1158),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1117:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1051)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(673),
	  /* template */
	  __webpack_require__(1159),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1118:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1044)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(674),
	  /* template */
	  __webpack_require__(1146),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1119:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(675),
	  /* template */
	  __webpack_require__(1140),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1120:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(676),
	  /* template */
	  __webpack_require__(1172),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1121:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(677),
	  /* template */
	  __webpack_require__(1169),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1122:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1045)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(678),
	  /* template */
	  __webpack_require__(1150),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1123:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(679),
	  /* template */
	  __webpack_require__(1165),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1124:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(680),
	  /* template */
	  __webpack_require__(1156),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1125:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(681),
	  /* template */
	  __webpack_require__(1152),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1126:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(682),
	  /* template */
	  __webpack_require__(1167),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1127:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1042)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(683),
	  /* template */
	  __webpack_require__(1142),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1128:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(684),
	  /* template */
	  __webpack_require__(1163),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1129:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1048)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(685),
	  /* template */
	  __webpack_require__(1154),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1130:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(686),
	  /* template */
	  __webpack_require__(1143),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1131:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(687),
	  /* template */
	  __webpack_require__(1148),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1132:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(688),
	  /* template */
	  __webpack_require__(1170),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1133:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(689),
	  /* template */
	  __webpack_require__(1144),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1134:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1046)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(690),
	  /* template */
	  __webpack_require__(1151),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1135:
/***/ (function(module, exports, __webpack_require__) {

	
	/* styles */
	__webpack_require__(1049)
	
	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(691),
	  /* template */
	  __webpack_require__(1155),
	  /* scopeId */
	  "data-v-63aa0c97",
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1136:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(692),
	  /* template */
	  __webpack_require__(1162),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1137:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(693),
	  /* template */
	  __webpack_require__(1147),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1138:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(694),
	  /* template */
	  __webpack_require__(1141),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1139:
/***/ (function(module, exports, __webpack_require__) {

	var Component = __webpack_require__(6)(
	  /* script */
	  __webpack_require__(695),
	  /* template */
	  __webpack_require__(1166),
	  /* scopeId */
	  null,
	  /* cssModules */
	  null
	)
	
	module.exports = Component.exports


/***/ }),

/***/ 1140:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "content-wrapper dashboard-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('el-row', [_c('el-col', {
	    attrs: {
	      "span": 8
	    }
	  }, [_c('div', {
	    staticClass: "box palette-Pink-300 bg",
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'devices'
	        })
	      }
	    }
	  }, [_c('div', {
	    staticClass: "box-header   palette-Pink-300 bg"
	  }, [_c('div', {
	    staticClass: "pull-right text-white box-tools"
	  }, [_c('span', {
	    staticClass: "text-white box-btn"
	  }, [_c('i', {
	    staticClass: "circle-nest-medium ti-car"
	  })]), _vm._v("    ")]), _vm._v(" "), _c('h3', {
	    staticClass: "box-title"
	  }, [_c('span', {
	    staticClass: "text-white"
	  }, [_vm._v("   Devices")])])]), _vm._v(" "), _c('div', {
	    staticClass: "box-body no-pad",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest "
	  }, [_c('div', {
	    staticClass: "wrap-no-pad text-white"
	  }, [_c('bars', {
	    attrs: {
	      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 0],
	      "gradient": ['#ffffff', '#ffffff']
	    }
	  }), _vm._v(" "), _c('h1', {
	    staticClass: "text-white"
	  }, [_c('strong', [(!_vm.loading) ? _c('animate-number', {
	    attrs: {
	      "from": 0,
	      "to": _vm.pagination.totalCount,
	      "duration": "1000",
	      "easing": "easeOutQuad"
	    }
	  }) : _vm._e()], 1)])], 1)])])])])], 1)], 1)])])
	},staticRenderFns: []}

/***/ }),

/***/ 1141:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('el-input', {
	    attrs: {
	      "placeholder": "Please input",
	      "type": _vm.showPassword ? 'text' : 'password',
	      "value": (_vm.value || '').toString()
	    },
	    on: {
	      "input": function (value) { return _vm.$emit('input', value); }
	    }
	  }, [_c('el-button', {
	    attrs: {
	      "slot": "append",
	      "icon": "el-icon-view",
	      "tabindex": "-1"
	    },
	    on: {
	      "click": function($event) {
	        _vm.showPassword = !_vm.showPassword
	      }
	    },
	    slot: "append"
	  })], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1142:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-dialog', {
	    staticClass: "video-search-dialog",
	    attrs: {
	      "title": "Historical lookup",
	      "visible": _vm.visible,
	      "width": "90%"
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$emit('update:visible', $event)
	      }
	    }
	  }, [_c('el-date-picker', {
	    attrs: {
	      "type": "datetimerange",
	      "range-separator": "To",
	      "start-placeholder": "Start date",
	      "end-placeholder": "End date",
	      "disabled": _vm.loading
	    },
	    model: {
	      value: (_vm.dateRange),
	      callback: function($$v) {
	        _vm.dateRange = $$v
	      },
	      expression: "dateRange"
	    }
	  }), _vm._v(" "), _c('el-table', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    ref: "table",
	    attrs: {
	      "data": _vm.tableData,
	      "default-sort": {
	        prop: 'startTime',
	        order: 'ascending'
	      },
	      "row-key": "id",
	      "height": "600",
	      "expand-row-keys": _vm.selectedIds
	    },
	    on: {
	      "selection-change": _vm.onSelectionChange
	    }
	  }, [_c('el-table-column', {
	    attrs: {
	      "type": "selection",
	      "width": "55"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "channelName",
	      "label": "Channel",
	      "filters": _vm.channelFilters,
	      "filter-method": _vm.filterByChannel
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "startTime",
	      "label": "Start Time",
	      "sortable": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ref) {
	        var ref_row = ref.row;
	        var id = ref_row.id;
	        var startTime = ref_row.startTime;
	
	        return [_vm._v("\n                " + _vm._s(startTime.format('YYYY-MM-DD HH:mm:ss')) + "\n            ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "endTime",
	      "label": "End Time",
	      "sortable": ""
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ref) {
	        var ref_row = ref.row;
	        var id = ref_row.id;
	        var endTime = ref_row.endTime;
	
	        return [_vm._v("\n                " + _vm._s(endTime.format('YYYY-MM-DD HH:mm:ss')) + "\n            ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "type": "expand"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ref) {
	        var ref_row = ref.row;
	        var id = ref_row.id;
	        var startTime = ref_row.startTime;
	        var endTime = ref_row.endTime;
	
	        return [(_vm.selected[id]) ? [_c('TimeRangeSlider', {
	          attrs: {
	            "min": startTime,
	            "max": endTime,
	            "step": 10
	          },
	          model: {
	            value: (_vm.selected[id].timeRange),
	            callback: function($$v) {
	              _vm.$set(_vm.selected[id], "timeRange", $$v)
	            },
	            expression: "selected[id].timeRange"
	          }
	        })] : _vm._e()]
	      }
	    }])
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.downloadDisabled,
	      "loading": _vm.downloading
	    },
	    on: {
	      "click": _vm.download
	    }
	  }, [_vm._v("\n            Download\n        ")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1143:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'users'
	      }
	    }
	  }, [_vm._v("\n            Users\n          ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Add user")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content user-content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-form', {
	    ref: "user",
	    attrs: {
	      "model": _vm.user,
	      "rules": _vm.rules,
	      "label-width": "120px",
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.user.name),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "name", $$v)
	      },
	      expression: "user.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Email",
	      "prop": "email"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.user.email),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "email", $$v)
	      },
	      expression: "user.email"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Password",
	      "prop": "password"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.user.password),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "password", $$v)
	      },
	      expression: "user.password"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Role",
	      "prop": "role"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Please select user role"
	    },
	    model: {
	      value: (_vm.user.role),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "role", $$v)
	      },
	      expression: "user.role"
	    }
	  }, _vm._l((_vm.roles), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Customer",
	      "prop": "customerId"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Please select customer"
	    },
	    model: {
	      value: (_vm.user.customerId),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "customerId", $$v)
	      },
	      expression: "user.customerId"
	    }
	  }, _vm._l((_vm.customers), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submitForm('user')
	      }
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        return _vm.resetForm('user')
	      }
	    }
	  }, [_vm._v("Reset")])], 1)], 1), _vm._v(" "), _c('hr')], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1144:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'userss'
	      }
	    }
	  }, [_vm._v("\n            Users\n          ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("View Users")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content user-content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-form', {
	    attrs: {
	      "model": _vm.user,
	      "label-width": "120px",
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.user.name) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Email",
	      "prop": "email"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.user.email) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Role",
	      "prop": "role"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.user.role) + "\n            ")]), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Customer",
	      "prop": "customerId"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.customer.name) + "\n            ")])], 1), _vm._v(" "), _c('hr')], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1145:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    class: ['online-status', {
	      'online-status--active': _vm.status === true,
	      'online-status--inactive': _vm.status === false,
	    }]
	  })
	},staticRenderFns: []}

/***/ }),

/***/ 1146:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper dashboard-wrapper"
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-4 col-xl-4"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body no-pad padding-fifthin",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest "
	  }, [_c('div', {
	    staticClass: "wrap-no-pad padding-fifthin"
	  }, [_c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 bor-right bor-bottom"
	  }, [_c('div', {
	    staticClass: "devin-table-dash centered pad-box"
	  }, [_c('i', {
	    staticClass: "palette-Pink-500 bg ti-shopping-cart-full"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "palette-Pink-500 text value"
	  }, [_vm._v("648")]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Items Sold")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6 bor-bottom"
	  }, [_c('div', {
	    staticClass: "devin-table-dash centered pad-box"
	  }, [_c('i', {
	    staticClass: "palette-Purple-500 bg ti-link"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "palette-Purple-500 text value"
	  }, [_vm._v("47.5"), _c('strong', [_vm._v("K")])]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Followers")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-sm-6 bor-right"
	  }, [_c('div', {
	    staticClass: "devin-table-dash centered pad-box"
	  }, [_c('i', {
	    staticClass: "palette-Deep-Purple-500 bg ti-wallet"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "value palette-Deep-Purple-500 text"
	  }, [_c('strong', [_vm._v("$")]), _vm._v("764")]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Daily Earnings")])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-sm-6"
	  }, [_c('div', {
	    staticClass: "devin-table-dash centered pad-box"
	  }, [_c('i', {
	    staticClass: "ti-bag palette-Light-Blue-500 bg"
	  }), _vm._v(" "), _c('div', {
	    staticClass: "value palette-Light-Blue-500 text"
	  }, [_vm._v("256")]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Products")])])])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-xl-4"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body no-pad padding-fifthin",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest "
	  }, [_c('div', {
	    staticClass: "wrap-no-pad padding-fifthin"
	  }, [_c('div', {
	    staticClass: "pad-box"
	  }, [_c('div', {
	    staticClass: "devin-table-dash bigger"
	  }, [_c('div', {
	    staticClass: "value"
	  }, [_vm._v("3059")]), _vm._v(" "), _c('div', {
	    staticClass: "trending trending-up palette-Amber-500 bg"
	  }, [_c('span', [_vm._v("15%")])]), _vm._v(" "), _c('div', {
	    staticClass: "label"
	  }, [_vm._v("Products Sold")])]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "el-chart-w"
	  }, [_c('bars', {
	    attrs: {
	      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 10, 0],
	      "gradient": ['#3bd6c6', '#3b5998']
	    }
	  })], 1), _vm._v(" "), _c('br')])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-4 col-xl-4"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body no-pad padding-fifthin",
	    staticStyle: {
	      "display": "block"
	    }
	  }, [_c('div', {
	    staticClass: "events-nest "
	  }, [_c('div', {
	    staticClass: "wrap-no-pad padding-fifthin"
	  }, [_c('div', {
	    staticClass: "pad-box"
	  }, [_c('div', {
	    staticClass: "element-info-with-icon smaller"
	  }, [_c('div', {
	    staticClass: "element-info-text"
	  }, [_c('h5', [_vm._v("Monthly Revenue")]), _vm._v(" "), _c('div', [_vm._v("Calculated every month")])])]), _vm._v(" "), _c('div', {
	    staticClass: "devin-progress-bar"
	  }, [_c('el-progress', {
	    staticClass: "circle-one",
	    attrs: {
	      "type": "circle",
	      "percentage": 63,
	      "width": 50,
	      "stroke-width": 2,
	      "status": "success"
	    }
	  }), _vm._v(" "), _c('el-progress', {
	    staticClass: "bor-left bor-right",
	    staticStyle: {
	      "padding": "0 10px"
	    },
	    attrs: {
	      "type": "circle",
	      "percentage": 75,
	      "width": 125,
	      "stroke-width": 6
	    }
	  }), _vm._v(" "), _c('el-progress', {
	    staticClass: "circle-two",
	    attrs: {
	      "type": "circle",
	      "percentage": 89,
	      "width": 50,
	      "stroke-width": 2,
	      "status": "exception"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "os-progress-bar primary"
	  })])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-6 col-xl-6"
	  }, [_c('div', {
	    staticClass: "food"
	  }, [_c('div', {
	    staticClass: "cover",
	    staticStyle: {
	      "background-image": "url(https://source.unsplash.com/category/food/800x600)"
	    }
	  }, [_c('label', [_c('i', {
	    staticClass: "ti-medall-alt"
	  }), _vm._v(" "), _c('font', [_vm._v("CULINARY")])], 1), _vm._v(" "), _c('a', {
	    staticClass: "download",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-truck"
	  })])]), _vm._v(" "), _c('div', {
	    staticClass: "info"
	  }, [_c('a', {
	    staticClass: "recipe",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "ti-pencil-alt"
	  }), _vm._v(" "), _c('font', [_c('h3', [_vm._v("76.5%")])])], 1), _vm._v(" "), _c('div', {
	    staticClass: "content-food"
	  }, [_c('ul', [_c('li', [_c('strong', [_vm._v("Sweetness")]), _vm._v(" "), _c('el-progress', {
	    attrs: {
	      "text-inside": true,
	      "stroke-width": 15,
	      "percentage": 85
	    }
	  })], 1), _vm._v(" "), _c('li', [_c('strong', [_vm._v("Acidity")]), _vm._v(" "), _c('el-progress', {
	    attrs: {
	      "text-inside": true,
	      "stroke-width": 15,
	      "percentage": 60
	    }
	  })], 1)])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-6 col-xl-6"
	  }, [_c('div', {
	    staticClass: "container-widget-two"
	  }, [_c('div', {
	    staticClass: "widget-two"
	  }, [_c('div', {
	    staticClass: "section section-graph"
	  }, [_c('div', {
	    staticClass: "graph-info"
	  }, [_c('i', {
	    staticClass: "ti-home"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "graph-info-big"
	  }, [_vm._v("454.757")]), _vm._v(" "), _c('span', {
	    staticClass: "graph-info-small"
	  }, [_vm._v("+5.78 (5.71%)")])]), _vm._v(" "), _c('div', {
	    attrs: {
	      "id": "graph"
	    }
	  }, [_c('bars', {
	    attrs: {
	      "data": [1, 2, 5, 9, 5, 10, 3, 5, 2, 5, 1, 8, 2, 9, 10, 8, 9, 5, 9],
	      "gradient": ['#ffffff', '#ffffff']
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "section section-info"
	  }, [_c('span', {
	    staticClass: "info-time"
	  }, [_vm._v("Today 2:25 PM")]), _vm._v(" "), _c('h3', {
	    staticClass: "info-title"
	  }, [_vm._v("Salt Lake City, Utah")]), _vm._v(" "), _c('div', {
	    staticClass: "info-block"
	  }, [_c('dl', [_c('dt', [_c('i', {
	    staticClass: "ti-stats-up"
	  })]), _vm._v(" "), _c('dt', [_vm._v("13.5 M")]), _vm._v(" "), _c('dd', [_vm._v("Shares Traded")])])]), _vm._v(" "), _c('div', {
	    staticClass: "info-block last"
	  }, [_c('dl', [_c('dt', [_c('i', {
	    staticClass: "ti-stats-down"
	  })]), _vm._v(" "), _c('dt', [_vm._v("28.44")]), _vm._v(" "), _c('dd', [_vm._v("Market Cap")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "section"
	  })])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
	    staticClass: "row"
	  }, [_c('div', {
	    staticClass: "col-md-7 col-xl-7 col-sm-12"
	  }, [_c('div', {
	    attrs: {
	      "id": "weather"
	    }
	  }, [_c('div', {
	    staticClass: "panelLeft"
	  }, [_c('div', {
	    staticClass: "top-cal-devin"
	  }, [_c('p', [_vm._v("JUNY 21, 2017")])]), _vm._v(" "), _c('img', {
	    attrs: {
	      "src": "https://source.unsplash.com/collection/431862/800x600",
	      "alt": ""
	    }
	  }), _vm._v(" "), _c('div', {
	    staticClass: "bottom"
	  }, [_c('div', {
	    staticClass: "temp"
	  }, [_c('p', [_vm._v("10°")]), _vm._v(" "), _c('p', [_vm._v("New York City")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "panelRight"
	  }, [_c('div', {
	    staticClass: "customHeight"
	  }, [_c('p', [_vm._v("Statistics")]), _vm._v(" "), _c('hr'), _vm._v(" "), _c('ul', [_c('li', [_c('i', {
	    staticClass: "wi wi-thermometer"
	  }), _vm._v(" "), _c('p', [_vm._v("35%")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "wi wi-day-rain-mix"
	  }), _vm._v(" "), _c('p', [_vm._v("Easterly")])]), _vm._v(" "), _c('li', [_c('i', {
	    staticClass: "wi wi-cloudy-gusts"
	  }), _vm._v(" "), _c('p', [_vm._v("7 mph")])])])]), _vm._v(" "), _c('div', {
	    staticClass: "remainingHeight"
	  }, [_c('ul', {
	    staticClass: "inline"
	  }, [_c('li', {
	    staticClass: "active"
	  }, [_vm._v("Today")]), _vm._v(" "), _c('li', [_vm._v("Week")])]), _vm._v(" "), _c('ul', {
	    staticClass: "forecast"
	  }, [_c('li', [_c('span', {
	    staticClass: "time"
	  }, [_vm._v("Now")]), _vm._v(" "), _c('span', {
	    staticClass: "temp"
	  }, [_vm._v("24°C")]), _vm._v(" "), _c('span', {
	    staticClass: "conditions"
	  }, [_vm._v("Cloudy")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "time"
	  }, [_vm._v("6 AM")]), _vm._v(" "), _c('span', {
	    staticClass: "temp"
	  }, [_vm._v("23°C")]), _vm._v(" "), _c('span', {
	    staticClass: "conditions"
	  }, [_vm._v("Cloudy")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "time"
	  }, [_vm._v("6:59 AM")]), _vm._v(" "), _c('span', {
	    staticClass: "temp"
	  }, [_vm._v("Sunrise")]), _vm._v(" "), _c('span', {
	    staticClass: "conditions"
	  }, [_vm._v("Cloudy")])]), _vm._v(" "), _c('li', [_c('span', {
	    staticClass: "time"
	  }, [_vm._v("7 AM")]), _vm._v(" "), _c('span', {
	    staticClass: "temp"
	  }, [_vm._v("24°C")]), _vm._v(" "), _c('span', {
	    staticClass: "conditions"
	  }, [_vm._v("Partly Cloudy")])])])])])])]), _vm._v(" "), _c('div', {
	    staticClass: "col-md-5 col-xl-5 col-sm-12"
	  }, [_c('div', {
	    staticClass: "widget"
	  }, [_c('div', {
	    staticClass: "widget__header"
	  }, [_c('h2', {
	    staticClass: "widget__header-title"
	  }, [_vm._v("\n                                  DNTM\n                                  "), _c('span', {
	    staticClass: "widget__header-author"
	  }, [_vm._v("\n                                    by Abine\n                                  ")])]), _vm._v(" "), _c('div', {
	    staticClass: "nav"
	  }, [_c('a', {
	    staticClass: "nav__item",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-cubes"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "nav__item",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-check-circle-o"
	  })]), _vm._v(" "), _c('a', {
	    staticClass: "nav__item",
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('i', {
	    staticClass: "fa fa-gear"
	  })])])]), _vm._v(" "), _c('div', {
	    staticClass: "widget__body"
	  }, [_c('div', {
	    staticClass: "flash"
	  }, [_c('strong', [_vm._v("All 6")]), _vm._v(" companies blocked now ")]), _vm._v(" "), _c('div', {
	    staticClass: "accordion"
	  }, [_c('div', {
	    staticClass: "accordion__item "
	  }, [_c('div', {
	    staticClass: "accordion__header"
	  }, [_c('i', {
	    staticClass: "fa fa-minus accordion__state-icon"
	  }), _vm._v(" "), _c('h2', [_vm._v("Social Networks")])]), _vm._v(" "), _c('div', {
	    staticClass: "accordion__body"
	  }, [_c('div', {
	    staticClass: "accordion__body-item"
	  }, [_c('i', {
	    staticClass: " fa ti-facebook"
	  }), _vm._v(" Facebook ")]), _vm._v(" "), _c('div', {
	    staticClass: "accordion__body-item"
	  }, [_c('i', {
	    staticClass: " fa ti-twitter"
	  }), _vm._v(" Twitter ")]), _vm._v(" "), _c('div', {
	    staticClass: "accordion__body-item"
	  }, [_c('i', {
	    staticClass: " fa ti-instagram"
	  }), _vm._v(" Instagram ")])])])])])])])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br')])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1147:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('header', {
	    staticClass: "main-header"
	  }, [_c('router-link', {
	    staticClass: "logo",
	    attrs: {
	      "to": {
	        name: 'dashboard'
	      }
	    }
	  }, [_c('span', {
	    staticClass: "logo-mini"
	  }, [_c('b', [_c('img', {
	    attrs: {
	      "src": "/static/img/header_logo_sys_icon.png",
	      "alt": "User Image"
	    }
	  })])]), _vm._v(" "), _c('span', {
	    staticClass: "logo-lg"
	  }, [_c('img', {
	    attrs: {
	      "src": "/static/img/header_logo_sys_white.png",
	      "alt": "User Image"
	    }
	  })])]), _vm._v(" "), _vm._m(0)], 1)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('nav', {
	    staticClass: "navbar navbar-static-top"
	  }, [_c('a', {
	    staticClass: "sidebar-toggle",
	    attrs: {
	      "href": "#",
	      "data-toggle": "offcanvas",
	      "role": "button"
	    }
	  }, [_c('span', {
	    staticClass: "sr-only"
	  }, [_vm._v("Toggle navigation")]), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "icon-bar"
	  })]), _vm._v(" "), _c('div', {
	    staticClass: "navbar-custom-menu"
	  }, [_c('ul', {
	    staticClass: "nav navbar-nav"
	  })])])
	}]}

/***/ }),

/***/ 1148:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'users'
	      }
	    }
	  }, [_vm._v("\n            Users\n          ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Edit user")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content user-content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-form', {
	    ref: "user",
	    attrs: {
	      "model": _vm.user,
	      "rules": _vm.rules,
	      "label-width": "120px",
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.user.name),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "name", $$v)
	      },
	      expression: "user.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Email",
	      "prop": "email"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.user.email),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "email", $$v)
	      },
	      expression: "user.email"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Password",
	      "prop": "password"
	    }
	  }, [_c('el-input', {
	    attrs: {
	      "placeholder": "Leave blank if the password should be the same"
	    },
	    model: {
	      value: (_vm.user.password),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "password", $$v)
	      },
	      expression: "user.password"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Role",
	      "prop": "role"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Please select user role"
	    },
	    model: {
	      value: (_vm.user.role),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "role", $$v)
	      },
	      expression: "user.role"
	    }
	  }, _vm._l((_vm.roles), function(item) {
	    return _c('el-option', {
	      key: item,
	      attrs: {
	        "label": item,
	        "value": item
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Customer",
	      "prop": "customerId"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Please select customer"
	    },
	    model: {
	      value: (_vm.user.customerId),
	      callback: function($$v) {
	        _vm.$set(_vm.user, "customerId", $$v)
	      },
	      expression: "user.customerId"
	    }
	  }, _vm._l((_vm.customers), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }), 1)], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submitForm('user')
	      }
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        return _vm.resetForm('user')
	      }
	    }
	  }, [_vm._v("Reset")])], 1)], 1), _vm._v(" "), _c('hr')], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1149:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'customers'
	      }
	    }
	  }, [_vm._v("Customers")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Edit Customer")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content customers-content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-form', {
	    ref: "customer",
	    attrs: {
	      "model": _vm.customer,
	      "rules": _vm.rules,
	      "label-width": "120px",
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.customer.name),
	      callback: function($$v) {
	        _vm.$set(_vm.customer, "name", $$v)
	      },
	      expression: "customer.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Api key",
	      "prop": "customerSecretKey"
	    }
	  }, [_vm._v("\n              " + _vm._s(_vm.customer.customerSecretKey) + "\n              "), _c('el-button', {
	    attrs: {
	      "disabled": !!_vm.customer.customerSecretKey
	    },
	    on: {
	      "click": _vm.generateKey
	    }
	  }, [_vm._v("Generate")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submitForm('customer')
	      }
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        return _vm.resetForm('customer')
	      }
	    }
	  }, [_vm._v("Reset")])], 1)], 1), _vm._v(" "), _c('hr')], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1150:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('el-button', {
	    staticClass: "float-right",
	    attrs: {
	      "type": "primary",
	      "icon": "el-icon-plus"
	    },
	    on: {
	      "click": _vm.handleAdd
	    }
	  }, [_vm._v("Add")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'devices'
	      }
	    }
	  }, [_vm._v("Devices")])], 1)])], 1), _vm._v(" "), _c('section', {
	    staticClass: "content device-content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('div', {
	    staticClass: "search-wrapper panel-heading col-sm-12"
	  }, [_c('form', {
	    staticClass: "device-search-form",
	    on: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.searchData($event)
	      }
	    }
	  }, [_c('input', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.search),
	      expression: "search"
	    }],
	    attrs: {
	      "type": "text",
	      "placeholder": "Search by serial, name, ICC Id, customer..."
	    },
	    domProps: {
	      "value": (_vm.search)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.searchData($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.search = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('select', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.activityFilter),
	      expression: "activityFilter"
	    }],
	    on: {
	      "change": [function($event) {
	        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
	          return o.selected
	        }).map(function(o) {
	          var val = "_value" in o ? o._value : o.value;
	          return val
	        });
	        _vm.activityFilter = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
	      }, _vm.applyGlobalFilters]
	    }
	  }, [_c('option', {
	    attrs: {
	      "value": "ALL"
	    }
	  }, [_vm._v("All devices")]), _vm._v(" "), _c('option', {
	    attrs: {
	      "value": "ACTIVE"
	    }
	  }, [_vm._v("Online devices")])]), _vm._v(" "), _c('button', {
	    attrs: {
	      "type": "submit"
	    }
	  }, [_vm._v("Search")])])]), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.tableData,
	      "row-class-name": _vm.tableRowClassName
	    },
	    on: {
	      "row-click": _vm.onRowClick
	    }
	  }, [_c('template', {
	    slot: "empty"
	  }, [_vm._v("Loading...")]), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "width": 10
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": _vm.isDeviceOnline(scope.row.serial) ?
	              'Online' :
	              'Offline',
	            "placement": "left"
	          }
	        }, [_c('OnlineStatus', {
	          attrs: {
	            "status": _vm.isDeviceOnline(scope.row.serial)
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "serial",
	      "label": "Serial",
	      "min-width": 15
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": "Name",
	      "min-width": 30
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "iccId",
	      "label": "ICC Id",
	      "min-width": 15
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "created",
	      "label": "Created",
	      "min-width": 30
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Last Online",
	      "min-width": 30
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_vm._v("\n                  " + _vm._s(_vm.formatLastActive(scope.row)) + "\n                ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "customer.name",
	      "label": "Customer",
	      "min-width": 40
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Action",
	      "width": "auto"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-row', {
	          staticClass: "device-actions-row"
	        }, [_c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "Make snapshot",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "default",
	            "icon": "el-icon-picture",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.currentDevice = scope.row;
	              _vm.snapshotVisible = true;
	            }
	          }
	        })], 1), _vm._v(" "), _c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "Xml File",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "default",
	            "icon": "el-icon-tickets",
	            "circle": ""
	          },
	          on: {
	            "click": [function($event) {
	              return _vm.getXml(scope.row)
	            }, function($event) {
	              $event.stopPropagation();
	              _vm.xmlVisible = true;
	              _vm.currentDevice = scope.row;
	              _vm.currentRow = scope.row.serial;
	            }]
	          }
	        })], 1), _vm._v(" "), _c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "Historical lookup",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "info",
	            "icon": "el-icon-date",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.currentDevice = scope.row;
	              _vm.videoSearchVisible = true;
	            }
	          }
	        })], 1), _vm._v(" "), _c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "Live stream",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "danger",
	            "icon": "el-icon-caret-right",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              _vm.currentDevice = scope.row;
	              _vm.liveStreamVisible = true;
	            }
	          }
	        })], 1), _vm._v(" "), _c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "Edit",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "primary",
	            "icon": "el-icon-edit",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.handleEdit(scope.row)
	            }
	          }
	        })], 1), _vm._v(" "), [(scope.row.disabled) ? _c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "Restore",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "success",
	            "icon": "el-icon-refresh",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.handleRestore(scope.row)
	            }
	          }
	        })], 1) : _c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "Delete",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "danger",
	            "icon": "el-icon-delete",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              $event.stopPropagation();
	              return _vm.handleDelete(scope.row)
	            }
	          }
	        })], 1)]], 2)]
	      }
	    }])
	  })], 2)], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('el-pagination', {
	    attrs: {
	      "background": "",
	      "page-size": _vm.pagination.pageSize,
	      "layout": "prev, pager, next, sizes",
	      "total": _vm.tableTotal,
	      "page-sizes": _vm.pagination.rowsPerPageItems,
	      "current-page": _vm.pagination.pageNum
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange
	    }
	  })], 1)])]), _vm._v(" "), _c('VideoSearchDialog', {
	    attrs: {
	      "device": _vm.currentDevice,
	      "visible": _vm.videoSearchVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.videoSearchVisible = $event
	      }
	    }
	  }), _vm._v(" "), _c('LiveStreamDialog', {
	    attrs: {
	      "device": _vm.currentDevice,
	      "visible": _vm.liveStreamVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.liveStreamVisible = $event
	      }
	    }
	  }), _vm._v(" "), _c('SnapshotDialog', {
	    attrs: {
	      "device": _vm.currentDevice,
	      "visible": _vm.snapshotVisible
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.snapshotVisible = $event
	      }
	    }
	  }), _vm._v(" "), _c('XmlDialog', {
	    attrs: {
	      "visible": _vm.xmlVisible,
	      "device": _vm.currentDevice,
	      "serial": _vm.currentRow,
	      "xmlData": _vm.xmlData,
	      "isSuccessful": _vm.isSuccessful,
	      "isLoading": _vm.isLoading,
	      "hasError": _vm.hasError
	    },
	    on: {
	      "update:visible": function($event) {
	        _vm.xmlVisible = $event
	      }
	    }
	  })], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 1151:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _vm._m(0)
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('aside', {
	    staticClass: "control-sidebar control-sidebar-light"
	  }, [_c('ul', {
	    staticClass: "nav navbar-stacked"
	  }, [_c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Black-100 bg ti-menu-alt"
	  }), _vm._v("Notifications\n        ")])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Deep-Purple-100 bg ti-menu-alt"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "palette-Deep-Purple-200 bg ti-shopping-cart-full"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "palette-Deep-Purple-400 bg ti-gift"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "palette-Deep-Purple-600 bg ti-truck"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "palette-Deep-Purple-800 bg ti-home"
	  }), _vm._v("Shipping proses of\n          "), _c('strong', [_vm._v("Robert Langdon")]), _vm._v(" is completed!\n          "), _c('small', [_vm._v("1m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Blue-A100 bg ti-user"
	  }), _vm._v("Meet new user\n          "), _c('strong', [_vm._v("Lilian Meirs")]), _vm._v(" "), _c('small', [_vm._v("23m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Red-A400 bg ti-cloud-down"
	  }), _vm._v(" "), _c('strong', [_vm._v("Robert")]), _vm._v(" added new request for ne item for refund\n          "), _c('small', [_vm._v("34m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Orange-200 bg ti-menu-alt"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "palette-Orange-400 bg ti-shopping-cart-full"
	  }), _vm._v(" "), _c('i', {
	    staticClass: "ti-more-alt"
	  }), _vm._v(" "), _c('span', {
	    staticClass: "palette-Orange-600 bg ti-gift"
	  }), _vm._v(" "), _c('br'), _vm._v("Shipping proses of\n          "), _c('strong', [_vm._v("Robert Langdon")]), _vm._v(" is completed!\n          "), _c('small', [_vm._v("40m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Amber-500 bg ti-comment-alt"
	  }), _vm._v("Mike Nilson commented Post\n          "), _c('br'), _vm._v("Like this one! Keep going!\n          "), _c('small', [_vm._v("50m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Cyan-300 bg ti-shopping-cart-full"
	  }), _vm._v("Amazing!\n          "), _c('strong', [_vm._v("Mike Nilson")]), _vm._v(" just purchased Your item\n          "), _c('small', [_vm._v("1h")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Light-Green-500 bg ti-image"
	  }), _vm._v(" "), _c('strong', [_vm._v("Lilian Meirs")]), _vm._v(" Posting new image cover, and just got 2.000 likes\n          "), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "alt": "",
	      "src": "https://source.unsplash.com/category/technology/500x200"
	    }
	  }), _vm._v(" "), _c('small', [_vm._v("1h 12m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Amber-500 bg ti-comment-alt"
	  }), _vm._v("Mike Nilson commented Post\n          "), _c('br'), _vm._v("Like this one! Keep going!\n          "), _c('small', [_vm._v("1h 39")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Cyan-300 bg ti-shopping-cart-full"
	  }), _vm._v("Amazing!\n          "), _c('strong', [_vm._v("Mike Nilson")]), _vm._v(" just purchased Your item\n          "), _c('br'), _vm._v(" "), _c('img', {
	    attrs: {
	      "alt": "",
	      "src": "https://source.unsplash.com/category/food/500x200"
	    }
	  }), _vm._v(" "), _c('small', [_vm._v("1h 45m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Cyan-300 bg ti-shopping-cart-full"
	  }), _vm._v("Amazing!\n          "), _c('strong', [_vm._v("Mike Nilson")]), _vm._v(" just purchased Your item\n          "), _c('small', [_vm._v("23m")])])]), _vm._v(" "), _c('li', [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_c('span', {
	    staticClass: "palette-Amber-500 bg ti-comment-alt"
	  }), _vm._v("Mike Nilson commented Post\n          "), _c('br'), _vm._v("Like this one! Keep going!\n          "), _c('small', [_vm._v("2h")])])])])])])
	}]}

/***/ }),

/***/ 1152:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-dialog', {
	    attrs: {
	      "title": "Snapshot",
	      "visible": _vm.visible
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$emit('update:visible', $event)
	      }
	    }
	  }, [_c('el-form', {
	    ref: "snapshotRequest",
	    attrs: {
	      "model": _vm.snapshotRequest,
	      "rules": _vm.rules
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Channels",
	      "label-width": "120px",
	      "prop": "channels"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "multiple": "",
	      "placeholder": "Please select channels"
	    },
	    model: {
	      value: (_vm.snapshotRequest.channels),
	      callback: function($$v) {
	        _vm.$set(_vm.snapshotRequest, "channels", $$v)
	      },
	      expression: "snapshotRequest.channels"
	    }
	  }, _vm._l((_vm.channels), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.channelIndex
	      }
	    })
	  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.snapshotRequest.error) ? _c('el-form-item', [_vm._v("Error: " + _vm._s(_vm.snapshotRequest.error))]) : _vm._e()], 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.loading,
	      "loading": _vm.loading
	    },
	    on: {
	      "click": _vm.makeSnapshot
	    }
	  }, [_vm._v("\n        Make Snapshot\n      ")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1153:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "time-range-slider"
	  }, [_c('div', {
	    staticClass: "time-range-slider__inputs"
	  }, [_c('el-input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##:##:##'),
	      expression: "'##:##:##'"
	    }],
	    key: ("from_" + _vm.version),
	    attrs: {
	      "value": _vm.value ? _vm.value[0].format('HH:mm:ss') : undefined
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.onInputBlur(0, $event)
	      }
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onInputBlur(0, $event)
	      }
	    }
	  }, [_c('template', {
	    slot: "prepend"
	  }, [_c('el-button', {
	    attrs: {
	      "icon": "el-icon-minus"
	    },
	    nativeOn: {
	      "mousedown": function($event) {
	        return _vm.onStepMouseDown(0, -1)
	      },
	      "mouseup": function($event) {
	        return _vm.onStepMouseUp($event)
	      },
	      "mouseleave": function($event) {
	        return _vm.onStepMouseUp($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('template', {
	    slot: "append"
	  }, [_c('el-button', {
	    attrs: {
	      "icon": "el-icon-plus"
	    },
	    nativeOn: {
	      "mousedown": function($event) {
	        return _vm.onStepMouseDown(0, 1)
	      },
	      "mouseup": function($event) {
	        return _vm.onStepMouseUp($event)
	      },
	      "mouseleave": function($event) {
	        return _vm.onStepMouseUp($event)
	      }
	    }
	  })], 1)], 2), _vm._v(" "), _c('el-input', {
	    directives: [{
	      name: "mask",
	      rawName: "v-mask",
	      value: ('##:##:##'),
	      expression: "'##:##:##'"
	    }],
	    key: ("to_" + _vm.version),
	    attrs: {
	      "value": _vm.value ? _vm.value[1].format('HH:mm:ss') : undefined
	    },
	    on: {
	      "blur": function($event) {
	        return _vm.onInputBlur(1, $event)
	      }
	    },
	    nativeOn: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.onInputBlur(1, $event)
	      }
	    }
	  }, [_c('template', {
	    slot: "prepend"
	  }, [_c('el-button', {
	    attrs: {
	      "icon": "el-icon-minus"
	    },
	    nativeOn: {
	      "mousedown": function($event) {
	        return _vm.onStepMouseDown(1, -1)
	      },
	      "mouseup": function($event) {
	        return _vm.onStepMouseUp($event)
	      },
	      "mouseleave": function($event) {
	        return _vm.onStepMouseUp($event)
	      }
	    }
	  })], 1), _vm._v(" "), _c('template', {
	    slot: "append"
	  }, [_c('el-button', {
	    attrs: {
	      "icon": "el-icon-plus"
	    },
	    nativeOn: {
	      "mousedown": function($event) {
	        return _vm.onStepMouseDown(1, 1)
	      },
	      "mouseup": function($event) {
	        return _vm.onStepMouseUp($event)
	      },
	      "mouseleave": function($event) {
	        return _vm.onStepMouseUp($event)
	      }
	    }
	  })], 1)], 2)], 1), _vm._v(" "), _c('el-slider', {
	    attrs: {
	      "value": _vm.unixRange,
	      "min": _vm.min.unix(),
	      "max": _vm.max.unix(),
	      "step": _vm.adjustedStep,
	      "range": "",
	      "format-tooltip": _vm.formatUnix
	    },
	    on: {
	      "input": _vm.onInput
	    }
	  })], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1154:
/***/ (function(module, exports, __webpack_require__) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-dialog', {
	    attrs: {
	      "title": "Your Xml File",
	      "visible": _vm.visible
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$emit('update:visible', $event)
	      }
	    }
	  }, [(_vm.isSuccessful) ? _c('h1', {
	    staticClass: "successIcon"
	  }, [_vm._v("✔")]) : _vm._e(), _vm._v(" "), (_vm.hasError) ? _c('img', {
	    staticClass: "errorIcon",
	    attrs: {
	      "src": __webpack_require__(1099)
	    }
	  }) : _vm._e(), _vm._v(" "), (_vm.isLoading) ? _c('img', {
	    staticClass: "loadingIcon",
	    attrs: {
	      "src": "https://upload.wikimedia.org/wikipedia/commons/b/b1/Loading_icon.gif"
	    }
	  }) : _vm._e(), _vm._v(" "), _c('textarea', {
	    directives: [{
	      name: "model",
	      rawName: "v-model",
	      value: (_vm.xmlData),
	      expression: "xmlData"
	    }],
	    attrs: {
	      "cols": "75",
	      "rows": "15",
	      "id": "txtName",
	      "type": "text"
	    },
	    domProps: {
	      "value": (_vm.xmlData)
	    },
	    on: {
	      "keyup": function($event) {
	        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
	        return _vm.sendXml($event)
	      },
	      "input": function($event) {
	        if ($event.target.composing) { return; }
	        _vm.xmlData = $event.target.value
	      }
	    }
	  }), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary",
	      "disabled": _vm.loading,
	      "loading": _vm.loading
	    },
	    on: {
	      "click": _vm.sendXml
	    }
	  }, [_vm._v("\n            Send Xml File\n        ")])], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 1155:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "fade"
	    }
	  }, [(_vm.loading) ? _c('span', {
	    staticClass: "root"
	  }, [_c('span', [_vm._v(".")]), _vm._v(" "), _c('span', [_vm._v(".")]), _vm._v(" "), _c('span', [_vm._v(".")])]) : _vm._e()])
	},staticRenderFns: []}

/***/ }),

/***/ 1156:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('video', {
	    key: _vm.src,
	    ref: "video",
	    attrs: {
	      "controls": "",
	      "muted": "",
	      "autoplay": "",
	      "playsinline": "",
	      "src": _vm.src
	    },
	    domProps: {
	      "muted": true
	    }
	  })
	},staticRenderFns: []}

/***/ }),

/***/ 1157:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('el-button', {
	    staticClass: "float-right",
	    attrs: {
	      "type": "primary",
	      "icon": "el-icon-plus"
	    },
	    on: {
	      "click": _vm.handleAdd
	    }
	  }, [_vm._v("Add")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'customers'
	      }
	    }
	  }, [_vm._v("\n            Customers\n          ")])], 1)])], 1), _vm._v(" "), _c('section', {
	    staticClass: "content customers-content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.list
	    }
	  }, [_c('template', {
	    slot: "empty"
	  }, [_vm._v("\n              Loading...\n            ")]), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": "Name",
	      "width": "180"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "created",
	      "label": "Created"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "align": "right"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-row', [_c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "View",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "success",
	            "icon": "el-icon-view",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              return _vm.handleView(scope.row)
	            }
	          }
	        })], 1), _vm._v(" "), _c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "Edit",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "primary",
	            "icon": "el-icon-edit",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              return _vm.handleEdit(scope.row)
	            }
	          }
	        })], 1), _vm._v(" "), _c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "Delete",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "danger",
	            "icon": "el-icon-delete",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              return _vm.handleDelete(scope.row)
	            }
	          }
	        })], 1)], 1)]
	      }
	    }])
	  })], 2)], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('el-pagination', {
	    attrs: {
	      "background": "",
	      "page-size": _vm.pagination.pageSize,
	      "layout": "prev, pager, next, sizes",
	      "total": _vm.pagination.totalCount,
	      "page-sizes": _vm.pagination.rowsPerPageItems,
	      "current-page": _vm.pagination.pageNum
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange
	    }
	  })], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1158:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "wrapper-404",
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'dashboard'
	        })
	      }
	    }
	  }, [_c('div', {
	    staticClass: "error-404"
	  }, [_vm._m(0), _vm._v(" "), _c('h1', [_c('vue-typer', {
	    attrs: {
	      "text": _vm.text,
	      "repeat": Infinity,
	      "shuffle": false,
	      "initial-action": "typing",
	      "pre-type-delay": 70,
	      "type-delay": 70,
	      "pre-erase-delay": 2000,
	      "erase-delay": 250,
	      "erase-style": "clear",
	      "erase-on-complete": false,
	      "caret-animation": "solid"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "moon"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "error-number"
	  }, [_c('span', [_vm._v("4")]), _vm._v(" "), _c('span', [_c('img', {
	    staticClass: "icon has-animation",
	    attrs: {
	      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('span', [_vm._v("3")])])
	}]}

/***/ }),

/***/ 1159:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('main', {
	    staticClass: "wrapper-404",
	    on: {
	      "click": function($event) {
	        return _vm.$router.push({
	          name: 'dashboard'
	        })
	      }
	    }
	  }, [_c('div', {
	    staticClass: "error-404"
	  }, [_vm._m(0), _vm._v(" "), _c('h1', [_c('vue-typer', {
	    attrs: {
	      "text": _vm.text,
	      "repeat": Infinity,
	      "shuffle": false,
	      "initial-action": "typing",
	      "pre-type-delay": 70,
	      "type-delay": 70,
	      "pre-erase-delay": 2000,
	      "erase-delay": 250,
	      "erase-style": "clear",
	      "erase-on-complete": false,
	      "caret-animation": "solid"
	    }
	  })], 1)]), _vm._v(" "), _c('div', {
	    staticClass: "moon"
	  })])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "error-number"
	  }, [_c('span', [_vm._v("4")]), _vm._v(" "), _c('span', [_c('img', {
	    staticClass: "icon has-animation",
	    attrs: {
	      "src": "https://image.flaticon.com/icons/svg/179/179595.svg",
	      "alt": ""
	    }
	  })]), _vm._v(" "), _c('span', [_vm._v("4")])])
	}]}

/***/ }),

/***/ 1160:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'customers'
	      }
	    }
	  }, [_vm._v("\n            Customers\n          ")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Add Customer")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content customers-content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-form', {
	    ref: "customer",
	    attrs: {
	      "model": _vm.customer,
	      "rules": _vm.rules,
	      "label-width": "120px",
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.customer.name),
	      callback: function($$v) {
	        _vm.$set(_vm.customer, "name", $$v)
	      },
	      expression: "customer.name"
	    }
	  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submitForm('customer')
	      }
	    }
	  }, [_vm._v("Create")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        return _vm.resetForm('customer')
	      }
	    }
	  }, [_vm._v("Reset")])], 1)], 1), _vm._v(" "), _c('hr')], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1161:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'customers'
	      }
	    }
	  }, [_vm._v("Customers")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("View Customer")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content customers-content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-form', {
	    ref: "customer",
	    attrs: {
	      "model": _vm.customer,
	      "rules": _vm.rules,
	      "label-width": "120px",
	      "label-position": "top"
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.customer.name))]), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Api key",
	      "prop": "customerSecretKey"
	    }
	  }, [_vm._v(_vm._s(_vm.customer.customerSecretKey))])], 1), _vm._v(" "), _c('hr')], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1162:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('footer', {
	    staticClass: "main-footer"
	  }, [_c('div', {
	    staticClass: "container-fluid"
	  }, [_c('div', {
	    staticClass: "pull-left"
	  }, [_c('p', [_vm._v("© Copyright " + _vm._s(_vm.year) + "\n          "), _vm._m(0), _vm._v(" All rights reserved.\n        ")]), _vm._v(" "), _c('p', [_vm._v("1945 Camino Vida Roble, Carlsbad, CA 92008")])]), _vm._v(" "), _vm._m(1)])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('strong', [_c('a', {
	    staticStyle: {
	      "color": "inherit"
	    },
	    attrs: {
	      "href": "http://www.novaassure.com"
	    }
	  }, [_vm._v("Nova Assure")]), _vm._v(".\n          ")])
	},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "pull-right"
	  }, [_c('p', [_vm._v("Toll free "), _c('a', {
	    attrs: {
	      "href": "tel:#1-800-734-9885"
	    }
	  }, [_vm._v("#1-800-734-9885")])])])
	}]}

/***/ }),

/***/ 1163:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'devices'
	      }
	    }
	  }, [_vm._v("Devices")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("View Device")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content device-content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.deviceLoading),
	      expression: "deviceLoading"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-form', {
	    ref: "device",
	    attrs: {
	      "model": _vm.device,
	      "label-width": "120px",
	      "label-position": "top"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    }
	  }, [_vm._v(_vm._s(_vm.device.name))])], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Serial",
	      "prop": "serial"
	    }
	  }, [_vm._v(_vm._s(_vm.device.serial))])], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "ICC Id",
	      "prop": "iccId"
	    }
	  }, [_vm._v(_vm._s(_vm.device.iccId))])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "lg": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Customer",
	      "prop": "customer.name"
	    }
	  }, [_vm._v(_vm._s(_vm.device.customer.name))])], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "Channels",
	      "prop": "channels"
	    }
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.device.channels
	    }
	  }, [_c('template', {
	    slot: "empty"
	  }, [(!_vm.deviceLoading) ? [_vm._v("No channels")] : [_vm._v("Loading...")]], 2), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Channel",
	      "prop": "channelIndex"
	    }
	  })], 2)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('h4', [_vm._v("Content")]), _vm._v(" "), _c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.contentLoading && !_vm.content.length),
	      expression: "contentLoading && !content.length"
	    }]
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.content
	    }
	  }, [_c('template', {
	    slot: "empty"
	  }, [(!_vm.contentLoading) ? [_vm._v("No content")] : [_vm._v("Loading...")]], 2), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Created",
	      "prop": "created"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ref) {
	        var created = ref.row.created;
	
	        return [_vm._v("\n                  " + _vm._s(created.format('YYYY-MM-DD HH:mm:ss')) + "\n                ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Start",
	      "prop": "startDateTime"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ref) {
	        var startDateTime = ref.row.startDateTime;
	
	        return [_vm._v("\n                  " + _vm._s(startDateTime.format('YYYY-MM-DD HH:mm:ss')) + "\n                ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Channel"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ref) {
	        var channelIndex = ref.row.channelIndex;
	
	        return [_vm._v("\n                  " + _vm._s(_vm.channelNames[channelIndex] || ("Index " + channelIndex)) + "\n                ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Status"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.status === 'ERROR' && scope.row.errorReason) ? _c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": scope.row.errorReason,
	            "placement": "top"
	          }
	        }, [_c('el-tag', {
	          attrs: {
	            "size": "medium",
	            "type": "danger"
	          }
	        }, [_vm._v(_vm._s(scope.row.status))])], 1) : _c('el-tag', {
	          attrs: {
	            "size": "medium",
	            "type": scope.row.status === 'ERROR' ? 'danger' : scope.row.status === 'COMPLETED' ? 'success' : 'info'
	          }
	        }, [_vm._v("\n                    " + _vm._s(scope.row.status) + "\n                  ")])]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Type",
	      "prop": "type"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Duration"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(ref) {
	        var duration = ref.row.duration;
	
	        return [_vm._v("\n                  " + _vm._s(duration.format('HH:mm:ss')) + "\n                ")]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "align": "right"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [(scope.row.artifactUrl) ? _c('el-button', {
	          attrs: {
	            "size": "mini",
	            "type": "success",
	            "icon": "el-icon-download"
	          },
	          on: {
	            "click": function($event) {
	              return _vm.handleContentDownload(scope.row)
	            }
	          }
	        }) : _vm._e()]
	      }
	    }])
	  })], 2), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('el-pagination', {
	    attrs: {
	      "background": "",
	      "page-size": _vm.pagination.pageSize,
	      "layout": "prev, pager, next, sizes",
	      "total": _vm.pagination.totalCount,
	      "page-sizes": _vm.pagination.rowsPerPageItems,
	      "current-page": _vm.pagination.pageNum
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange
	    }
	  })], 1)], 1)], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1164:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('section', {
	    staticClass: "content"
	  }, [_c('el-dialog', {
	    attrs: {
	      "title": "Login",
	      "visible": true,
	      "size": "tiny"
	    }
	  }, [_c('div', {
	    staticClass: "account-box"
	  }, [_c('el-form', {
	    ref: "login",
	    attrs: {
	      "model": _vm.inputs,
	      "label-width": "120px",
	      "label-position": "top"
	    },
	    nativeOn: {
	      "submit": function($event) {
	        $event.preventDefault();
	        return _vm.formSubmit($event)
	      }
	    }
	  }, [_c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "inputUsernameEmail"
	    }
	  }, [_vm._v("Username or email")]), _vm._v(" "), _c('el-input', {
	    staticClass: "input-shell",
	    class: {
	      error: _vm.$v.inputs.email.$error
	    },
	    attrs: {
	      "type": "text",
	      "id": "inputUsernameEmail"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.inputs.email.$touch()
	      }
	    },
	    model: {
	      value: (_vm.inputs.email),
	      callback: function($$v) {
	        _vm.$set(_vm.inputs, "email", (typeof $$v === 'string' ? $$v.trim() : $$v))
	      },
	      expression: "inputs.email"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group"
	  }, [_c('label', {
	    attrs: {
	      "for": "inputPassword"
	    }
	  }, [_vm._v("Password")]), _vm._v(" "), _c('PasswordInput', {
	    staticClass: "input-shell",
	    class: {
	      error: _vm.$v.inputs.password.$error
	    },
	    attrs: {
	      "autocomplete": "current-password"
	    },
	    on: {
	      "input": function($event) {
	        return _vm.$v.inputs.password.$touch()
	      }
	    },
	    model: {
	      value: (_vm.inputs.password),
	      callback: function($$v) {
	        _vm.$set(_vm.inputs, "password", $$v)
	      },
	      expression: "inputs.password"
	    }
	  })], 1), _vm._v(" "), _c('div', {
	    staticClass: "form-group has-error"
	  }, [_c('label', {
	    directives: [{
	      name: "show",
	      rawName: "v-show",
	      value: (!!_vm.serverErrors),
	      expression: "!!serverErrors"
	    }]
	  }, [_vm._v(_vm._s(_vm.serverErrors))])]), _vm._v(" "), _c('button', {
	    staticClass: "btn btn btn-primary pull-right",
	    attrs: {
	      "type": "submit"
	    },
	    on: {
	      "click": _vm.formSubmit
	    }
	  }, [_vm._v("\n            Log In\n            "), _c('DotsLoading', {
	    attrs: {
	      "loading": !!_vm.loginPromise
	    }
	  })], 1)]), _vm._v(" "), _c('a', {
	    staticClass: "forgotLnk",
	    attrs: {
	      "href": "#"
	    }
	  })], 1)])], 1)])
	},staticRenderFns: []}

/***/ }),

/***/ 1165:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('el-dialog', {
	    attrs: {
	      "title": "Live stream",
	      "visible": _vm.visible
	    },
	    on: {
	      "update:visible": function($event) {
	        return _vm.$emit('update:visible', $event)
	      }
	    }
	  }, [_c('el-form', {
	    ref: "streamRequest",
	    attrs: {
	      "model": _vm.streamRequest,
	      "rules": _vm.rules
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 12
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Channels",
	      "label-width": "120px",
	      "prop": "channels"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "multiple": "",
	      "placeholder": "Please select channels"
	    },
	    model: {
	      value: (_vm.streamRequest.channels),
	      callback: function($$v) {
	        _vm.$set(_vm.streamRequest, "channels", $$v)
	      },
	      expression: "streamRequest.channels"
	    }
	  }, _vm._l((_vm.channels), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.channelIndex
	      }
	    })
	  }), 1)], 1)], 1)], 1), _vm._v(" "), (_vm.streamRequest.error) ? _c('el-form-item', [_vm._v("Error: " + _vm._s(_vm.streamRequest.error))]) : _vm._e()], 1), _vm._v(" "), _c('span', {
	    staticClass: "dialog-footer",
	    attrs: {
	      "slot": "footer"
	    },
	    slot: "footer"
	  }, [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": _vm.startStream
	    }
	  }, [_vm._v("Confirm")])], 1)], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1166:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('aside', {
	    staticClass: "main-sidebar"
	  }, [_c('div', [_c('section', {
	    staticClass: "sidebar"
	  }, [_c('div', {
	    staticClass: "user-panel"
	  }, [_vm._m(0), _vm._v(" "), _c('div', {
	    staticClass: "info"
	  }, [_c('p', [_vm._v("Good Job,")]), _vm._v(" "), _c('p', [_c('small', [_vm._v(_vm._s(_vm.user.email))])]), _vm._v(" "), _c('div', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'logout'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "ti-power-off"
	  }), _vm._v(" "), _c('small', [_vm._v("Logout")])])], 1)]), _vm._v(" "), _c('img', {
	    staticClass: "bg-user",
	    attrs: {
	      "src": "/static/img/avatar-bg.png",
	      "alt": "User Image"
	    }
	  })]), _vm._v(" "), _c('ul', {
	    staticClass: "sidebar-menu"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'devices'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "ti-desktop"
	  }), _vm._v(" "), _c('span', [_vm._v("Devices")])])], 1), _vm._v(" "), (_vm.isAdmin) ? [_c('li', {
	    staticClass: "header"
	  }, [_vm._v("ADMIN")]), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'customers'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "ti-crown"
	  }), _vm._v(" "), _c('span', [_vm._v("Customers")])])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'users'
	      }
	    }
	  }, [_c('i', {
	    staticClass: "ti-user"
	  }), _vm._v(" "), _c('span', [_vm._v("Users")])])], 1)] : _vm._e()], 2)])])])
	},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "image"
	  }, [_c('img', {
	    staticClass: "img-circle",
	    attrs: {
	      "src": "/static/img/avatar2.png",
	      "alt": "User Image"
	    }
	  })])
	}]}

/***/ }),

/***/ 1167:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'devices'
	      }
	    }
	  }, [_vm._v("Devices")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Stream")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading && !_vm.videos.length),
	      expression: "loading && !videos.length"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, _vm._l((_vm.grid), function(row, row_index) {
	    return _c('el-row', {
	      key: ("row" + row_index)
	    }, _vm._l((row), function(video, column_index) {
	      return _c('el-col', {
	        key: ("row" + column_index),
	        attrs: {
	          "md": 24,
	          "lg": 12
	        }
	      }, [_c('Player', {
	        attrs: {
	          "src": video
	        }
	      })], 1)
	    }), 1)
	  }), 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1168:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', {
	    staticClass: "wrapper",
	    attrs: {
	      "id": "app"
	    }
	  }, [_c('router-view')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1169:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'devices'
	      }
	    }
	  }, [_vm._v("Devices")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Edit Device")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content device-content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-form', {
	    ref: "device",
	    attrs: {
	      "model": _vm.device,
	      "rules": _vm.rules,
	      "label-width": "120px",
	      "label-position": "top"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.device.name),
	      callback: function($$v) {
	        _vm.$set(_vm.device, "name", $$v)
	      },
	      expression: "device.name"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Serial",
	      "prop": "serial"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.device.serial),
	      callback: function($$v) {
	        _vm.$set(_vm.device, "serial", $$v)
	      },
	      expression: "device.serial"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "ICC Id",
	      "prop": "iccId"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.device.iccId),
	      callback: function($$v) {
	        _vm.$set(_vm.device, "iccId", $$v)
	      },
	      expression: "device.iccId"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "channels",
	      "prop": "channels"
	    }
	  }, [_c('template', {
	    slot: "label"
	  }, [_vm._v("\n                channels\n                "), _c('el-button', {
	    attrs: {
	      "type": "success",
	      "icon": "el-icon-plus",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.addChannel
	    }
	  }, [_vm._v("Add")])], 1), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.device.channels
	    }
	  }, [_c('template', {
	    slot: "empty"
	  }, [_vm._v("Loading...")]), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          attrs: {
	            "inline-message": true,
	            "prop": ("channels." + (scope.$index) + ".name"),
	            "rules": {
	              required: true,
	              message: 'Please input device channel name',
	              trigger: 'blur'
	            }
	          }
	        }, [_c('el-input', {
	          model: {
	            value: (_vm.device.channels[scope.$index].name),
	            callback: function($$v) {
	              _vm.$set(_vm.device.channels[scope.$index], "name", $$v)
	            },
	            expression: "device.channels[scope.$index].name"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Channel",
	      "prop": "channelIndex"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          attrs: {
	            "prop": ("channels." + (scope.$index) + ".channelIndex"),
	            "rules": {
	              type: 'number',
	              required: true,
	              message: 'Please input device channel index',
	              trigger: 'blur'
	            }
	          }
	        }, [_c('el-input-number', {
	          attrs: {
	            "min": 0,
	            "max": 10
	          },
	          model: {
	            value: (_vm.device.channels[scope.$index].channelIndex),
	            callback: function($$v) {
	              _vm.$set(_vm.device.channels[scope.$index], "channelIndex", $$v)
	            },
	            expression: "device.channels[scope.$index].channelIndex"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "align": "right"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-button', {
	          attrs: {
	            "size": "mini",
	            "type": "danger",
	            "icon": "el-icon-minus",
	            "disabled": _vm.device.channels.length <= 1
	          },
	          on: {
	            "click": function($event) {
	              return _vm.handleRemove(scope.$index)
	            }
	          }
	        }, [_vm._v("Remove")])]
	      }
	    }])
	  })], 2)], 2), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submitForm('device')
	      }
	    }
	  }, [_vm._v("Save")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        return _vm.resetForm('device')
	      }
	    }
	  }, [_vm._v("Reset")])], 1)], 1), _vm._v(" "), _c('hr')], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1170:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('el-button', {
	    staticClass: "float-right",
	    attrs: {
	      "type": "primary",
	      "icon": "el-icon-plus"
	    },
	    on: {
	      "click": _vm.handleAdd
	    }
	  }, [_vm._v("Add")]), _vm._v(" "), _c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'users'
	      }
	    }
	  }, [_vm._v("\n            Users\n          ")])], 1)])], 1), _vm._v(" "), _c('section', {
	    staticClass: "content user-content"
	  }, [_c('div', {
	    directives: [{
	      name: "loading",
	      rawName: "v-loading",
	      value: (_vm.loading),
	      expression: "loading"
	    }],
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.list
	    }
	  }, [_c('template', {
	    slot: "empty"
	  }, [_vm._v("\n              Loading...\n            ")]), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "name",
	      "label": "Name"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "email",
	      "label": "Email"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "role",
	      "label": "Role"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "created",
	      "label": "Created"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "prop": "updated",
	      "label": "Updated"
	    }
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "align": "right"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-row', [_c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "View",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "success",
	            "icon": "el-icon-view",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              return _vm.handleView(scope.row)
	            }
	          }
	        })], 1), _vm._v(" "), _c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "Edit",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "primary",
	            "icon": "el-icon-edit",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              return _vm.handleEdit(scope.row)
	            }
	          }
	        })], 1), _vm._v(" "), _c('el-tooltip', {
	          staticClass: "item",
	          attrs: {
	            "effect": "dark",
	            "content": "Delete",
	            "placement": "top-start"
	          }
	        }, [_c('el-button', {
	          staticClass: "btn-rounded",
	          attrs: {
	            "type": "danger",
	            "icon": "el-icon-delete",
	            "circle": ""
	          },
	          on: {
	            "click": function($event) {
	              return _vm.handleDelete(scope.row)
	            }
	          }
	        })], 1)], 1)]
	      }
	    }])
	  })], 2)], 1), _vm._v(" "), _c('div', {
	    staticClass: "box-footer"
	  }, [_c('el-pagination', {
	    attrs: {
	      "background": "",
	      "page-size": _vm.pagination.pageSize,
	      "layout": "prev, pager, next, sizes",
	      "total": _vm.pagination.totalCount,
	      "page-sizes": _vm.pagination.rowsPerPageItems,
	      "current-page": _vm.pagination.pageNum
	    },
	    on: {
	      "size-change": _vm.handleSizeChange,
	      "current-change": _vm.handleCurrentChange
	    }
	  })], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1171:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('div', [_c('app-header'), _vm._v(" "), _c('app-sidebar'), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('app-footer'), _vm._v(" "), _c('control-sidebar')], 1)
	},staticRenderFns: []}

/***/ }),

/***/ 1172:
/***/ (function(module, exports) {

	module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
	  return _c('transition', {
	    attrs: {
	      "name": "el-zoom-in-top"
	    }
	  }, [_c('div', {
	    staticClass: "content-wrapper"
	  }, [_c('section', {
	    staticClass: "content-header"
	  }, [_c('ol', {
	    staticClass: "breadcrumb"
	  }, [_c('li', [_c('router-link', {
	    attrs: {
	      "to": "/"
	    }
	  }, [_c('i', {
	    staticClass: "ti-home"
	  })])], 1), _vm._v(" "), _c('li', [_c('router-link', {
	    attrs: {
	      "to": {
	        name: 'devices'
	      }
	    }
	  }, [_vm._v("Devices")])], 1), _vm._v(" "), _c('li', {
	    staticClass: "active"
	  }, [_c('a', {
	    attrs: {
	      "href": "#"
	    }
	  }, [_vm._v("Add Device")])])])]), _vm._v(" "), _c('section', {
	    staticClass: "content device-content"
	  }, [_c('div', {
	    staticClass: "box"
	  }, [_c('div', {
	    staticClass: "box-body"
	  }, [_c('el-form', {
	    ref: "device",
	    attrs: {
	      "model": _vm.device,
	      "rules": _vm.rules,
	      "label-width": "120px",
	      "label-position": "top"
	    }
	  }, [_c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.device.name),
	      callback: function($$v) {
	        _vm.$set(_vm.device, "name", $$v)
	      },
	      expression: "device.name"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Serial",
	      "prop": "serial"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.device.serial),
	      callback: function($$v) {
	        _vm.$set(_vm.device, "serial", $$v)
	      },
	      expression: "device.serial"
	    }
	  })], 1)], 1), _vm._v(" "), _c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "ICC Id",
	      "prop": "iccId"
	    }
	  }, [_c('el-input', {
	    model: {
	      value: (_vm.device.iccId),
	      callback: function($$v) {
	        _vm.$set(_vm.device, "iccId", $$v)
	      },
	      expression: "device.iccId"
	    }
	  })], 1)], 1)], 1), _vm._v(" "), (_vm.isAdmin) ? _c('el-row', {
	    attrs: {
	      "gutter": 20
	    }
	  }, [_c('el-col', {
	    attrs: {
	      "md": 24,
	      "lg": 8
	    }
	  }, [_c('el-form-item', {
	    attrs: {
	      "label": "Customer",
	      "prop": "customer"
	    }
	  }, [_c('el-select', {
	    attrs: {
	      "placeholder": "Please select customer"
	    },
	    model: {
	      value: (_vm.device.customer.id),
	      callback: function($$v) {
	        _vm.$set(_vm.device.customer, "id", $$v)
	      },
	      expression: "device.customer.id"
	    }
	  }, _vm._l((_vm.customers), function(item) {
	    return _c('el-option', {
	      key: item.id,
	      attrs: {
	        "label": item.name,
	        "value": item.id
	      }
	    })
	  }), 1)], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('hr'), _vm._v(" "), _c('el-form-item', {
	    attrs: {
	      "label": "channels",
	      "prop": "channels"
	    }
	  }, [_c('template', {
	    slot: "label"
	  }, [_vm._v("\n                channels\n                "), _c('el-button', {
	    attrs: {
	      "type": "success",
	      "icon": "el-icon-plus",
	      "size": "mini"
	    },
	    on: {
	      "click": _vm.addChannel
	    }
	  }, [_vm._v("Add")])], 1), _vm._v(" "), _c('el-table', {
	    staticStyle: {
	      "width": "100%"
	    },
	    attrs: {
	      "data": _vm.device.channels
	    }
	  }, [_c('template', {
	    slot: "empty"
	  }, [_vm._v("Loading...")]), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Name",
	      "prop": "name"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          attrs: {
	            "inline-message": true,
	            "prop": ("channels." + (scope.$index) + ".name"),
	            "rules": {
	              required: true,
	              message: 'Please input device channel name',
	              trigger: 'blur',
	            }
	          }
	        }, [_c('el-input', {
	          model: {
	            value: (_vm.device.channels[scope.$index].name),
	            callback: function($$v) {
	              _vm.$set(_vm.device.channels[scope.$index], "name", $$v)
	            },
	            expression: "device.channels[scope.$index].name"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "label": "Channel",
	      "prop": "channelIndex"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-form-item', {
	          attrs: {
	            "prop": ("channels." + (scope.$index) + ".channelIndex"),
	            "rules": {
	              type: 'number',
	              required: true,
	              message: 'Please input device channel index',
	              trigger: 'blur',
	            }
	          }
	        }, [_c('el-input-number', {
	          attrs: {
	            "min": 0,
	            "max": 10
	          },
	          model: {
	            value: (_vm.device.channels[scope.$index].channelIndex),
	            callback: function($$v) {
	              _vm.$set(_vm.device.channels[scope.$index], "channelIndex", $$v)
	            },
	            expression: "device.channels[scope.$index].channelIndex"
	          }
	        })], 1)]
	      }
	    }])
	  }), _vm._v(" "), _c('el-table-column', {
	    attrs: {
	      "align": "right"
	    },
	    scopedSlots: _vm._u([{
	      key: "default",
	      fn: function(scope) {
	        return [_c('el-button', {
	          attrs: {
	            "size": "mini",
	            "type": "danger",
	            "icon": "el-icon-minus",
	            "disabled": _vm.device.channels.length <= 1
	          },
	          on: {
	            "click": function($event) {
	              return _vm.handleRemove(scope.$index)
	            }
	          }
	        }, [_vm._v("Remove")])]
	      }
	    }])
	  })], 2)], 2), _vm._v(" "), _c('el-form-item', [_c('el-button', {
	    attrs: {
	      "type": "primary"
	    },
	    on: {
	      "click": function($event) {
	        return _vm.submitForm('device')
	      }
	    }
	  }, [_vm._v("Create")]), _vm._v(" "), _c('el-button', {
	    on: {
	      "click": function($event) {
	        return _vm.resetForm('device')
	      }
	    }
	  }, [_vm._v("Reset")])], 1)], 1), _vm._v(" "), _c('hr')], 1)])])])])
	},staticRenderFns: []}

/***/ }),

/***/ 1448:
/***/ (function(module, exports) {

	/* (ignored) */

/***/ })

});


// WEBPACK FOOTER //
// static/js/app.d5739041e3484047407c.js